<template>
  <keep-alive>
    <top-navbar 
      :currentRoute="$route" 
      :filter="false" 
      :numberOrder="orderNum"
      :fileBtn="showFileBtn ? 'Скачать файл заказа' : ''"
      @downloadFile="downloadFile"
    ></top-navbar>
  </keep-alive>

  <transition name="fade">
    <section v-if="!isReady">
      <div class="container-loading">
        <span class="loader loader-default loader-dark"></span>
      </div>
    </section>
  </transition>

  <transition name="fade">
    <div v-if="isReady">
      <section class="container-content">

        <!-- Блок 6.3.3.1-А.  Детальная информация по блоку в разделе 6.3.3.3. -->
        <div class="accordion-block-header">
          <!-- Номер Заказа. При создании не заполняется. Заполняется при обмене с 1С из 1С -->
          <!-- <div v-show="orderNum" class="container-acc-header">
            № 12345
          </div> -->
          <!-- Текущая дата -->
          <div class="container-acc-header">
            Дата создания: 
            <span class="order-color-date">{{ objectOrder.created }}</span>
          </div>
          <!-- При создании заказа Черновик -->
          <div class="container-acc-header">
            Статус: 
            <span class="draft" style="min-width: 189px">{{ objectOrder.status }}</span>
          </div>
          <!-- устанавливается после сохранения из поля Желаемая дата доставки -->
          <!-- <div v-show="!isEmpty(objectOrder.shipmentDate)" class="container-acc-header">
            Дата отгрузки: 
            <span class="order-color-date">{{ objectOrder.shipmentDate }}</span>
          </div> -->
        </div>

        <!-- Блок для вывода уведомлений по Заказу. 
          В блок должны выводиться уведомления в процессе исполнения алгоритма расчета стоимости 
          (п. 8.1)  -->
        <div class="error-message" v-show="errorText != ''">
          <span>{{ errorText }}</span>
        </div>
        <div class="success-message" v-show="successText != ''">
          <span>{{ successText }}</span>
        </div>

      <div class="accordion-block">
        <div class="accordion-block-item">

          <!-- Блок с общими данными по Заказу.  
          Детальная информация по блоку в разделе 6.3.3.5 -->
          <div class="accordion-block-content">
            <div class="row">
              <div class="col-12 col-lg-6">
                <!-- Заполняется автоматически по карточке пользователя -->
                <div class="container-center">
                  <div class="group-label-input">
                    <label>Контрагент</label>
                    <!-- {{ typePage }} -->
                    <input type="text" v-model="objectOrder.contrAgent.title" readonly>
                  </div>
                </div>
                <!-- Тип продукции в заказе. Поле с типом раскрывающийся список. Варианты списка:
                - TI (если Company.TIGroup = 1)
                - BI (если Company.BIGroup = 1)
                Пояснение: Доступность опций зависит от наличия действующего договора BI или TI. -->
                <div class="container-center">
                  <div class="group-label-input" v-if="typePage == 'view'">
                    <label>Тип продукции</label>
                    <input type="text" v-model="objectOrder.division" :readonly="typePage == 'view'">
                  </div>
                  <div class="group-label-input" v-else>
                    <label>Тип продукции</label>
                    <select @click="getAddons = true" v-model="objectOrder.division">
                      <option v-for="(type) in objectOrderDraft.division" :key="type" :value="type">{{type}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <!-- Ручной ввод -->
                <div class="container-center">
                  <div class="group-label-input">
                    <label>Номер заказа клиента</label>
                    <input type="text" v-model="objectOrder.orderNumberClient" :readonly="typePage == 'view'">
                  </div>
                </div>
                <div v-if="objectOrder.groupOrders.length > 0 && typePage == 'view'" class="container-center">
                  <div class="group-label-input">
                    <label class="custom-label">
                      Группа заказов 
                      <div class="icon-question" title="Заказы с доставкой на один адрес">
                        <mdicon 
                          name="help-circle-outline" 
                          width="18" 
                          height="18" 
                        />
                      </div>
                    </label>
                    <div class="group-orders">
                      <a 
                        v-for="(order) in objectOrder.groupOrders" 
                        :key="order" 
                        :href="'/order/detail?id=' + order.id + '&type=view'" 
                        target="_blank" 
                        class="group-orders-item"
                      >
                        <span>{{ order.name }}</span>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- Раскрывающийся список с множественным выбором. 
                В список должны выводиться Заказы пользователя, находящиеся в любом статусе 
                кроме статусов Закрыт, Отменен, Черновик. -->
                <!-- убрать поле, на MVP не будет -->
                <!-- <div class="container-center">
                  <div class="group-label-input">
                    <label>Номер связанного заказа</label>
                    <input type="text" v-model="objectOrder.RelatedOrder">
                  </div>
                </div> -->
                <!-- Должен присваиваться автоматически при клике на элементе З3. 
                Логика формирования номера группы заказов указана в описании элемента З3 ТЗ. -->
                <!-- убрать поле, на MVP не будет -->
                <!-- <div class="container-center">
                  <div class="group-label-input">
                    <label>Номер группы заказов</label>
                    <input type="text" v-model="objectOrder.Group">
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Блок с информацией по доставке Заказа. 
      При открытии страницы блок должен быть свернут. 
      Возможность развернуть блок должна появляться только если заполнен хотя бы один товар в блоке Д. 
      Детальная информация по блоку в разделе 6.3.3.11 -->
      <accordion class="accordion-block" :openBlock="true" title="Информация по доставке">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="container-center">
              <div class="group-label-input" v-if="typePage == 'view'">
                <label>Способ доставки</label>
                <input type="text" v-model="objectOrder.shipmentMethod" :readonly="typePage == 'view'">
              </div>
              <div class="group-label-input" v-else>
                <!-- если самовывоз - все остальные поля блока недоступны для редактирования -->
                <label>Способ доставки</label>
                <select @click="getAddons = true" v-model="objectOrder.shipmentMethod">
                  <option v-for="(method) in objectOrderDraft.deliveryMethods" :key="method" :value="method">{{method}}</option>
                </select>
              </div>
            </div>
            <div class="container-center">
              <div class="group-label-input" v-if="typePage == 'view'">
                <label>Регион</label>
                <input type="text" v-model="objectOrder.region.name" readonly>
              </div>
              <div class="group-label-input" v-else>
                <label>Регион</label>
                <select 
                  v-model="objectOrder.region_id"
                  :class="{'disableField': isEmpty(objectOrder.shipmentMethod)}" 
                  v-bind:disabled="isEmpty(objectOrder.shipmentMethod) || typePage == 'view'"
                  @click="getAddons = true"
                >
                  <option v-for="(region, index) in objectOrderDraft.regions" :key="index" :value="region.id">{{region.name}}</option>
                </select>
                <!-- <mdicon 
                  class="down-field-icon" 
                  name="chevron-down" 
                  width="18" 
                  height="18" 
                /> -->
              </div>
            </div>
            <div class="container-center">
              <div class="group-label-input">
                <label>Адрес доставки</label>
                <input 
                  v-if="typePage == 'view'"
                  v-model="objectOrder.shipmentAddress"
                  type="text"
                  readonly
                >
                <shipment-address-field
                  v-else
                  :addressStr = "objectOrder.shipmentAddress"
                  :shipmentMethod = "objectOrder.shipmentMethod"
                  :incorrectAddress = "incorrectAddress"
                  :haveNewAddress = "haveNewAddress"
                  :selectedAddress = "selectedAddress"
                  @addShipmentAddress = "addShipmentAddress"
                  @showFormAddAddressMethod = "showFormAddAddressMethod"
                  @editShipmentAddress = "editShipmentAddress"
                  @haveNewAddressFalse = "haveNewAddressFalse"
                >
                </shipment-address-field>
              </div>
            </div>
          </div>
          <!-- При клике должен раскрываться календарь с отображением допустимых дат отгрузки. 
          Допустимый интервал отгрузки должен определяться по алгоритму 8.2 ТЗ -->
          <div class="col-12 col-lg-6">

            <!-- Ручной ввод -->
            <div class="container-center">
              <div class="group-label-input">
                <label>Грузополучатель, КПП</label>
                <input 
                  type="text" 
                  v-model="objectOrder.consignee"
                  :readonly="typePage == 'view'"
                >
              </div>
            </div>

            <!-- Ручной ввод -->
            <div class="container-center">
              <div class="group-label-input">
                <label>ИНН</label>
                <input 
                  type="text" 
                  :class="{'error-field': incorrectInn}"
                  v-model="objectOrder.inn"
                  v-mask="'############'"
                  placeholder="юр. лицо - 10 цифр, ИП - 12 цифр"
                  :readonly="typePage == 'view'"
                >
              </div>
            </div>

            <div class="container-center">
              <div class="group-label-input">
                <label>Пользователь</label>
                <input type="text" v-model="objectOrder.user" readonly>
              </div>
            </div>

          </div>
          <div class="col-12">
            <div class="container-center">
              <div class="group-label-input w-100">
                <label>Дополнительная информация</label>
                <textarea 
                  v-model="objectOrder.addInformation"
                  name="text" 
                  :readonly="typePage == 'view'"
                ></textarea>  
              </div>
            </div>
          </div>
        </div>
      </accordion>

      <div class="container-for-load-items">
        <div v-show="loadingItems" class="loading-items-block">
          <span class="loader loader-default loader-light"></span>
        </div>
        <!-- Машины с товарами -->
        <div v-for="(car) in objectOrder.cars" :key="car.carId" :value="car">
          <accordion 
            class="accordion-block" 
            :openBlock="true" 
            :weight="formatNumber(car.orderWeight)" 
            :load="car.occupancyRate" 
            :summ="formatNumber(car.total)" 
            :title="objectOrder.shipmentMethod == 'Доставка' ? 'Товары. Машина №' + car.carId : 'Товары'"
            type="goods"
            :carId="car.carId"
            @delCar="delCar"
          >
            <div class="col-12 col-lg-6">
              <div class="group-label-input start-content">
                <label>Желаемая дата отгрузки</label>
                <DatePicker 
                  v-model="car.shipmentDate" 
                  class="customDate"
                  :disabled-dates="minDate"
                  language="ru"
                  :weekStartsOn="1"
                  :clearable="true"
                  :class="getActive()" 
                  v-bind:disabled="typePage == 'view'"
                  @input="updateShipmentDate(car)"
                />
              </div>
            </div>

            <table class="order-table">
              <tr>
                <!-- При клике на кнопку должно происходить удаление из блока Д товаров, 
                для которых выбран чек-бокс Д6 -->
                <th v-show="typePage != 'view'" rowspan="2" class="pointer" style="width: 29px;" title="Удалить выбранные товары" @click="delSelectedItems(car.carId)">
                  <img src="@/assets/img/del.svg">
                </th>
                <th rowspan="2">Наименование/Артикул</th>
                <!-- Источник цены для товара. При клике должен раскрываться список доступных видов 
                цены для данного пользователя для данного товара. 
                В верхней части раскрывающегося списка должно быть поле для ввода. 
                Значения списка должны фильтроваться по тексту, указанному в поле ввода. 
                Пример реализации:  СМОТРИМ ТЗ, ТАМ СКРИН СТР 33-->
                <th rowspan="2">Вид цены</th>
                <th rowspan="2">Цена с НДС</th>
                <th colspan="4" class="text-center">Количество </th>
                <th rowspan="2">Общая сумма</th>
              </tr>
              <tr>
                <th>ед</th>
                <th>м2</th>
                <th>м3</th>
                <th>кг</th>
              </tr>
              <tr v-for="item in car.items" :key="item.rowId" :value="item.rowId">
                <!-- Чек-бокс. При клике на кнопку Д5 должно происходить удаление из блока Д товаров, 
                для которых выбран чек-бокс Д5. -->
                <td v-show="typePage != 'view'">
                  <input 
                  type="checkbox" 
                  :value="item.rowId"
                  :checked="isSelectedRemoveItem(car.carId, item.rowId)"
                  @change="handleItemsRemoveChange(car.carId, item.rowId)"
                  >
                </td>
                <td>
                  <span class="tab-text-name">{{ item.name }}</span><br>
                  <span class="tab-text-art">{{ item.sku }}</span>
                </td>
                <td class="relative">
                  <span v-if="typePage == 'view'" class="price-type vid-ps btn-default">
                    <span class="center-content">
                      {{ item.selectedPriceType.title }}
                    </span>
                  </span>

                  <span 
                    v-else 
                    class="price-type vid-ps btn-default" 
                    :class="getBgPriceType(item)"
                    @click="togglePriceTypes(car, item)"
                  >
                    <span v-if="isEmpty(item.selectedPriceType)" class="center-content">
                      Выберите тип
                      <mdicon 
                        name="chevron-right" 
                        width="18" 
                        height="18" 
                      />
                    </span>
                    <span v-else class="center-content">
                      {{ item.selectedPriceType.title }}
                      <mdicon 
                        v-show="typePage != 'view'"
                        name="chevron-right" 
                        width="18" 
                        height="18" 
                      />
                    </span>
                  </span>

                  <div class="container-price-types" v-show="showPriceTypes == (car.carId + '-' + item.rowId)">
                    <span class="container-icon" title="Закрыть" @click="closeModal()">
                      <mdicon name="close" width="16" height="16"/> 
                    </span>
                    <div v-for="(type) in item.priceTypes" 
                      :key="type.title" 
                      :value="type.title" 
                      class="container-price-types-item" 
                      @click="getPriceType(type, item)"
                    >
                      {{ type.title }}
                    </div>
                  </div>

                </td>
                <td>{{ formatNumber(item.selectedPriceType.price) }}</td>

                <td class="td-edit-field" v-if="typePage == 'view'">
                  <span>{{ formatNumber(item.quantity) }}</span>
                </td>
                <td class="td-edit-field" v-else>
                  <input v-if="showEditQuantity == (car.carId + '-' + item.rowId)" class="quantity-field" type="number" v-model="item.quantity">
                  <span v-else>{{ formatNumber(item.quantity) }}</span>
                  <span v-if="showEditQuantity == (car.carId + '-' + item.rowId)" class="td-edit-field-icon" @click="calculateQuantity(item, car.carId)">
                    <mdicon name="check-bold" width="16" height="16" /> 
                  </span>
                  <span v-else class="td-edit-field-icon" @click="getEditQuantity(car.carId, item.rowId)">
                    <mdicon name="pencil" width="16" height="16"/> 
                  </span>
                </td>

                <td class="td-edit-field" v-if="typePage == 'view'">
                  <span>{{ formatNumber(item.area) }}</span>
                </td>
                <td class="td-edit-field" v-else>
                  <input v-if="showEditArea == (car.carId + '-' + item.rowId)" class="quantity-field" type="number" v-model="item.area">
                  <span v-else>{{ formatNumber(item.area) }}</span>
                  <span v-if="showEditArea == (car.carId + '-' + item.rowId)" class="td-edit-field-icon" @click="calculateArea(item, car.carId)">
                    <mdicon name="check-bold" width="16" height="16" /> 
                  </span>
                  <span v-else class="td-edit-field-icon" @click="getEditArea(car.carId, item.rowId)">
                    <mdicon name="pencil" width="16" height="16"/> 
                  </span>
                </td>

                <td class="td-edit-field" v-if="typePage == 'view'">
                  <span>{{ formatNumber(item.volume) }}</span>
                </td>
                <td class="td-edit-field" v-else>
                  <input v-if="showEditVolume == (car.carId + '-' + item.rowId)" class="quantity-field" type="number" v-model="item.volume">
                  <span v-else>{{ formatNumber(item.volume) }}</span>
                  <span v-if="showEditVolume == (car.carId + '-' + item.rowId)" class="td-edit-field-icon" @click="calculateVolume(item, car.carId)">
                    <mdicon name="check-bold" width="16" height="16" /> 
                  </span>
                  <span v-else class="td-edit-field-icon" @click="getEditVolume(car.carId, item.rowId)">
                    <mdicon name="pencil" width="16" height="16"/> 
                  </span>
                </td>

                <td>{{ formatNumber(item.weight) }}</td>
                <td class="text-right">{{ formatNumber(getItogItemSumm(item)) }}</td>
              </tr>
            </table>
            <!-- {{ getAddons }} -->
            <!-- {{ originOrderAllItems }} -->
            <span 
              v-if="typePage != 'view'"
              class="btn-add vid-ps btn-default"
              @click="getOrderItems(car.carId)"
              v-show="(originItemsByCarId.get(String(car.carId))?.length || 0) > 0"
            >
              <mdicon 
                name="plus" 
                width="18" 
                height="18" 
              />
              Добавить товар
            </span>

            <div 
              v-show="typePage != 'view'"
              v-if="objectOrder.region_id && objectOrder.shipmentMethod != 'Самовывоз'" 
              class="col-12 related-orders"
              :class="[this.isEmpty(car.shipmentDate) || car.items.length < 1 || car.occupancyRate <= 0 || car.occupancyRate >= 100 ? 'disable-block' : '']"
            >
              <label>Связанные заказы</label>
              <div class="group-label-input start-content">
                <!-- {{ formatDate(car.shipmentDate) }}
                {{ car.relatedOrders }}
                {{ allRelatedOrders }} -->
                <select-component 
                  :selected = "car.relatedOrders"
                  :options = "allRelatedOrders.filter( order => order.shipmentDate == formatDate(car.shipmentDate) && (order.carId == car.carId || order.carId == 0))"
                  selectedType = "exactly"
                  defaultFields = "false"
                  typeSelector = "relatedOrders"
                  :clearSelected = "clearSelected"
                  @selectedElements="(selected) => selectedRelatedOrders(car.carId, selected)"
                ></select-component>

              </div>
            </div>
            <div 
              v-show="typePage == 'view'"
              v-if="objectOrder.region_id && objectOrder.shipmentMethod != 'Самовывоз'" 
              class="col-12 related-orders view-orders"
            >
              <label class="custom-label mr-8">
                Связанные заказы 
                <div class="icon-question" title="Заказы, которые доставляются в одной машине на несколько адресов">
                  <mdicon 
                    name="help-circle-outline" 
                    width="18" 
                    height="18" 
                  />
                </div>
              </label>
              <div class="group-orders">
                <a 
                  v-for="(order) in car.relatedOrders" 
                  :key="order" 
                  :href="'/order/detail?id=' + order.id + '&type=view'" 
                  target="_blank" 
                  class="group-orders-item"
                >
                  {{ order.name }}
                </a>
              </div>
            </div>

          </accordion>
        </div>

        <div v-if="showModalAddItems" class="modal-vue modal-add-items" :class="{ 'fade-in': showModalAddItems, 'fade-out': !showModalAddItems }">
            <span class="container-icon" title="Закрыть" @click="closeModal('addItems')">
            <mdicon name="close" width="22" height="22"/> 
          </span>
            
          <div class="container-loading-modal" v-if="!flagGetItems">
            <span class="loader loader-default loader-dark"></span>
          </div>
          <div v-else>
              <p class="modal-title">Выберите товары</p>
              <div class="group-label-input">
                <input type="text" v-model="textForSearchItemsAdd" placeholder="Введите артикул или название товара ">
                <span v-show="searchingOrderAllItems" class="load-field-icon loader loader-for-field loader-dark-small"></span>
              </div>
              <div v-if="(originItemsByCarId.get(String(currentCarId))?.length || 0) > 0">
                <div 
                  class="block-cb block-field-hover"
                  @click="selectOrderAllItems(currentCarId)"
                >
                  <input 
                    type="checkbox" 
                    :value="currentCarId"
                    v-model="addOrderAllItems"
                  >
                  <div class="blockAddFields">
                    <span class="tab-text-art">Отметить все</span>
                  </div>
                </div>
                <div class="container-add-items">
                <div 
                  class="block-cb block-field-hover"
                  v-for="item in (itemsByCarId.get(String(currentCarId)) ?? [])"
                  :key="item.id"
                  @click="addItem(item.id, selectedItems)"
                  :class="[selectedItemsByCarId.includes(item.id) ? 'active-field' : '']"
                >
                  <input 
                    type="checkbox" 
                    :value="item.id"
                    v-model="selectedItemsByCarId"
                  >
                  <div class="blockAddFields">
                    <span class="tab-text-name">{{ item.name }}</span>
                    <span class="tab-text-art">{{ item.sku }}</span>
                  </div>
                </div>
              </div>
              <button 
                class="btn btn-default"
                type="submit"
                @click="saveItems(currentCarId)"
              >
                Сохранить
              </button>
            </div>
            <div v-else class="text-center">
              Товары не найдены.
            </div>
          </div>

        </div>

        <span 
          v-if="objectOrder.shipmentMethod == 'Доставка' && objectOrder.region_id && !carsHaveEmptyItems && typePage != 'view'"
          class="btn-add vid-ps btn-default mt-20"
          @click="addOrderCar()"
        >
          <mdicon 
            name="plus" 
            width="18" 
            height="18" 
          />
          Добавить машину
        </span>

        <!-- Блок с дополнительными услугами -->
        <accordion class="accordion-block accordion-pd-0 create-block" :openBlock="openBlockServices" title="Дополнительные услуги" type="services">
          <div class="block-services">
            <div class="block-services-item service-head">
              <img v-if="typePage != 'view'" src="@/assets/img/del.svg" class="pointer" title="Удалить выбранные услуги" @click="delSelectedService()">
              <span>Вид услуги</span>
            </div>
            <div class="block-services-item service-head">
              <span>Применить к машине:</span>
            </div>
          </div>
          <div class="block-services" v-for="(service) in objectOrder.services" :key="service.id">
            <div class="block-services-item vid-service">
              <span>
                <input 
                  v-if="typePage != 'view'"
                  type="checkbox" 
                  :value="service.id"
                  v-model="selectedServicesDel"
                >{{ service.title }}</span>
            </div>
            <div class="block-services-item for-good">
              <div v-if="typePage != 'view'" class="group-label-input container-input-btn-service"> 
                <span 
                  class="btn-add vid-ps btn-default"
                  @click="getOrderCarsService(service.id)"
                >
                  <mdicon 
                    name="plus" 
                    width="18" 
                    height="18" 
                  />
                  Добавить машину
                </span>
              </div>  
              <div class="group-good" v-for="(itemService) in service.cars" :key="itemService.id">
                <div>
                  <span class="tab-text-name">Машина №{{ itemService.id }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showModalAddItemsService" class="modal-vue modal-add-items" :class="{ 'fade-in': showModalAddItemsService, 'fade-out': !showModalAddItemsService }">
              <span class="container-icon" title="Закрыть" @click="closeModal('addItemsService')">
              <mdicon name="close" width="22" height="22"/> 
            </span>
              
            <div>
              <p class="modal-title">Выберите машины</p>
              <div v-if="orderCarsService.length > 0">
                <div class="container-add-items">
                  <div 
                    class="block-cb block-field-hover"
                    @click="selectOrderAllCarsService(selectService)"
                  >
                    <input 
                      type="checkbox" 
                        :value="selectService"
                      v-model="addOrderAllCarsService"
                    >
                    <div class="blockAddFields">
                      <span class="tab-text-art">Отметить все</span>
                    </div>
                  </div>
                  <div 
                    class="block-cb block-field-hover"
                    v-for="(car) in orderCarsService"
                    :key="car"
                    @click.stop="addCar(car)"
                    :class="[selectedCarsService.includes(car) ? 'active-field' : '']"
                  >
                    <input 
                      type="checkbox" 
                      :value="car"
                      v-model="selectedCarsService"
                    >
                    <div class="blockAddFields">
                      <span class="tab-text-name">Машина №{{ car }}</span>
                    </div>
                  </div>
                </div>
                <button 
                  class="btn btn-default"
                  type="submit"
                  @click="saveCarsService(selectService)"
                >
                  Сохранить
                </button>
            </div>
            <div v-else class="text-center">
              Машины не найдены.
            </div>
          </div>
            
          </div>

          <span 
            v-show="typePage != 'view'"
            class="btn-add vid-ps btn-default"
            @click="addOrderServices()"
          >
            <mdicon 
              name="plus" 
              width="18" 
              height="18" 
            />
            Добавить услугу
          </span>

          <div v-if="showModalAddService" class="modal-vue modal-add-items" :class="{ 'fade-in': showModalAddService, 'fade-out': !showModalAddService }">
            <span class="container-icon" title="Закрыть" @click="closeModal">
              <mdicon name="close" width="22" height="22"/> 
            </span> 

            <div class="container-loading-modal" v-if="!flagGetService">
              <span class="loader loader-default loader-dark"></span>
            </div>
            <div v-else>
              <p class="modal-title">Выберите услуги</p>
              <div class="container-add-items">
                <div 
                  class="block-cb block-field-hover"
                  @click="selectAllServices()"
                >
                  <input 
                    type="checkbox" 
                    value="1"
                    v-model="addAllServices"
                  >
                  <div class="blockAddFields">
                    <span class="tab-text-art">Отметить все</span>
                  </div>
                </div>
                <div 
                  class="block-cb block-field-hover"
                  v-for="(service) in orderServices"
                  :key="service"
                  @click="addService(service.id)"
                  :class="[selectedServices.includes(service.id) ? 'active-field' : '']"
                >
                  <input 
                    type="checkbox" 
                    :value="service.id"
                    v-model="selectedServices"
                  >
                  <div class="blockAddFields">
                    <span class="tab-text-name">{{ service.title }}</span>
                    <span class="tab-text-art">{{ service.description }}</span>
                  </div>
                </div>
              </div>
              <button 
                class="btn btn-default"
                type="submit"
                @click="saveService()"
              >
                Сохранить
              </button>
            </div>
          </div>
        </accordion>
      </div>

      <!-- Чаты --> 
      <accordion 
        v-if="typePage == 'view' && (objectOrder.status == 'На согласовании (Поставщик)' || objectOrder.status == 'На согласовании (Клиент)' ||
          objectOrder.status == 'В работе' || objectOrder.status == 'Отменен' || objectOrder.status == 'Отгружен'
        )" 
        class="accordion-block accordion-pd-0 chat-block" 
        :openBlock="true" 
        title="Чат" 
        type="chat"
      >
        <div class="container-for-load-items">
          <div v-show="loadingMessages" class="loading-items-block chat-load">
            <span class="loader loader-default loader-dark"></span>
          </div>
          <div class="chat-messages-block" ref="chatContainer">

            <div v-for="(message) in orderMessages" :key="message">
              <div class="chat-message" :class="[message.userId == parseInt(userID) ? 'current-user-message' : '']">
                <div class="message-text chat-message-of-query" :id="message.id">
                  {{ message.messageText }}

                  <div v-if="message.fileLinks && message.fileLinks.length > 0" class="chat-files">
                    <div v-for="(file, index) in message.fileLinks" :key="index" class="chat-files-item">
                      <a :href="file.link" download title="Скачать файл">
                        <div class="icon-file">
                          <mdicon name="file-outline" width="13" height="13"/> 
                        </div>
                        <div class="extension-file">
                          {{ file.name }}
                        </div>
                      </a>
                    </div>
                  </div>

                </div>
                <div class="message-time">
                  {{ formattedTime(message.created) }}
                </div>
              </div>
            </div>

            <div v-for="(message) in sendingMessages" :key="message">
              <div class="chat-message current-user-message">

                <div v-if="message.send == 0" class="load-field-icon loader loader-for-field loader-dark-small"></div>
                <div v-else-if="message.error == 1" class="error-send-message" @click="sendMessage(message)" title="Повторить отправку">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 29.535 29.535" style="enable-background:new 0 0 29.535 29.535;" xml:space="preserve">
                    <g><path style="fill: rgb(204, 0, 0);" d="M14.768,0C6.609,0,0,6.609,0,14.768c0,8.155,6.609,14.767,14.768,14.767s14.766-6.612,14.766-14.767 C29.534,6.609,22.927,0,14.768,0z M14.768,27.126c-6.826,0-12.359-5.532-12.359-12.359c0-6.828,5.533-12.362,12.359-12.362 S27.128,7.94,27.128,14.768C27.128,21.594,21.594,27.126,14.768,27.126z" fill="#030104"></path>
                      <polygon style="fill: rgb(204, 0, 0);" points="16.338,17.962 16.938,5.601 12.625,5.601 13.227,17.962 " fill="#030104"></polygon>
                      <path style="fill: rgb(204, 0, 0);" d="M14.781,19.323c-1.445,0-2.455,1.011-2.455,2.485c0,1.418,0.982,2.482,2.398,2.482h0.057 c1.473,0,2.428-1.064,2.428-2.482C17.182,20.334,16.227,19.323,14.781,19.323z" fill="#030104"></path></g>
                  </svg>
                </div>

                <div class="message-text">
                  {{ message.message_text }}
                  <div v-if="message.files && message.files.length > 0" class="chat-files">
                    <div v-for="(file, index) in message.files" :key="index" class="chat-files-item">
                      <div class="icon-file">
                        <mdicon name="file-outline" width="13" height="13"/> 
                      </div>
                      <div class="extension-file">{{ file.name }}</div>
                    </div>
                  </div>

                </div>
                <div class="message-time">
                  <span v-if="message.send == 1 && message.error == 0">{{ message.created }}</span>
                  <span v-else-if="message.send == 1 && message.error == 1" style="font-size: 9px;">Сообщение не отправлено</span>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="chat-container-new-message">

          <div class="chat-files">
            <div v-for="(file, index) in files" :key="index" class="chat-files-item">
              <div class="del-btn" @click="removeFile(index)" title="Удалить файл">
                <mdicon name="close" width="22" height="22"/> 
              </div>
              <div class="icon-file">
                <mdicon name="file-outline" width="13" height="13"/> 
              </div>
              <div class="extension-file">
                {{ file.name }} 
                <span>
                  {{ (file.size > 1024 * 1024)
                    ? (file.size / (1024 * 1024)).toFixed(2) + 'MB'
                    : (file.size / 1024).toFixed(0) + 'KB' }}
                </span>
              </div>
            </div>
          </div>

          <div v-if="!this.isEmpty(errorMessage)" class="chat-errors">
            {{ errorMessage }}
          </div>

          <input type="file" ref="fileInput" style="display: none;" @change="handleFileChange" multiple accept=".doc,.docx,.xls,.xlsx,.pdf,.jpeg,.jpg,.png,.csv,.txt"/>

          <div class="chat-new-message">
            <div class="content-message">
              <div class="chat-add-files" @click="openFileDialog" title="Прикрепить файлы">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.0124 6.30434L6.80595 11.3494C6.16816 11.9675 5.30308 12.3148 4.40106 12.3148C3.49904 12.3148 2.63397 11.9675 1.99615 11.3494C1.35832 10.7314 1 9.89312 1 9.01903C1 8.14495 1.35832 7.30671 1.99615 6.68862L7.20252 1.64352C7.62776 1.23148 8.20449 1 8.8058 1C9.40717 1 9.9839 1.23148 10.4091 1.64352C10.8343 2.05557 11.0732 2.61442 11.0732 3.19713C11.0732 3.77985 10.8343 4.3387 10.4091 4.75074L5.19704 9.79584C4.98443 10.0019 4.69607 10.1176 4.3954 10.1176C4.09472 10.1176 3.80637 10.0019 3.59376 9.79584C3.38115 9.5898 3.26171 9.31043 3.26171 9.01903C3.26171 8.72769 3.38115 8.44826 3.59376 8.24223L8.40357 3.58691" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <input type="text" placeholder="Введите сообщение" v-model="newMessage" @keyup.enter="sendMessage()" >
            </div>
            <div class="send" title="Отправить" @click="sendMessage()">
              <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.9999 7.7368L1 14.4736L3.99998 7.7368L1 1L16.9999 7.7368Z" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.94727 7.73682H16.9998" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </accordion>

      <!-- Блок 6.3.3.1-З.  Детальная информация по блоку в разделе 6.3.3.13 -->
      <!-- <div>КНОПКИ</div> -->
  
      </section>

      <div class="container-buttons">
        <!-- <button class="btn btn-default" type="submit">
          <mdicon name="filter" width="17px"/> 
          Разделить
        </button> -->
        <button 
          class="btn btn-default" 
          type="submit" 
          @click="copyOrder()" 
          v-show="typePage == 'view'"
          v-bind:disabled="toDisableBtn" 
        >
          <mdicon name="content-copy" width="17px"/> 
          Копировать
        </button>

        <button 
          class="btn btn-default" 
          type="submit" 
          @click="editOrder()" 
          v-show="typePage == 'view' && objectOrder.status == 'Черновик'"
          v-bind:disabled="toDisableBtn" 
        >
          <mdicon name="pencil" width="17px"/> 
          Изменить
        </button>

        <button 
          class="btn btn-cancel" 
          type="submit" 
          @click="cancelOrder()" 
          v-bind:disabled="toDisableBtn"
          v-show="getStatuses()"
        >
          <span v-if="loadCancelOrder" class="loader loader-for-btn"></span>
          <div v-else>
            <mdicon name="close" width="17px"/> 
            Отменить
          </div>
        </button>

        <button 
          class="btn btn-success" 
          type="submit" 
          @click="approveOrder()"
          v-bind:disabled="toDisableBtn"
          v-show="getStatuses()"
        >
          <span v-if="loadApproveOrder" class="loader loader-for-btn"></span>
          <div v-else>
            <mdicon name="tray-arrow-down" width="17px"/> 
            Согласовать
          </div>
        </button>

        <button 
          class="btn btn-default" 
          type="submit" 
          @click="calculateOrder()" 
          v-show="typePage != 'view'"
          v-bind:disabled="toDisableBtn"
        >
          <mdicon name="view-grid-outline" width="17px"/> 
          Рассчитать
        </button>

        <button 
          class="btn btn-default" 
          type="submit" 
          @click="saveOrder()" 
          v-bind:disabled="toDisableBtn"
          v-show="typePage != 'view'"
        > 
          <span v-if="loadSaveOrder" class="loader loader-for-btn"></span>
          <div v-else>
            <mdicon name="tray-arrow-down" width="17px"/> 
            Сохранить
          </div>
        </button>
        
        <button 
          class="btn btn-success" 
          type="submit" 
          @click="postOrder()" 
          v-bind:disabled="toDisableBtn"
          v-show="typePage == 'view' && objectOrder.status == 'Черновик'"
        >
          <span v-if="loadPostOrder" class="loader loader-for-btn"></span>
          <div v-else>
          <mdicon name="file-check-outline" width="17px"/> 
          Разместить
          </div>
        </button>
      </div>

    </div>
  </transition>

  <address-form
    v-if="showFormAddAddress"
    :newAddressArrayForm="newAddressArrayForm"
    @saveAddress = "saveAddress"
    @closeModal = "closeModal"
    @updateNewAddressArrayForm = "updateNewAddressArrayForm"
  ></address-form>

  <confirm-modal ref="confirmModal"></confirm-modal>

  <div v-if="showModalAddItems || showModalAddService || showModalAddItemsService || showFormAddAddress" class="overlay"></div>

</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import Accordion from "../components/Accordion.vue";
import GlobalRequest from "@/plugins/globalRequest";
import DatePicker from 'vuejs3-datepicker';
import ShipmentAddressField from '../components/ShipmentAddressField.vue';
import AddressForm from '../components/AddressForm.vue';
import ConfirmModal from '../components/ConfirmModal.vue';
import SelectComponent from "../components/SelectComponent.vue";
import { mask } from 'vue-the-mask';

export default {
  name: 'OrderCreatePage',
  components: {
    TopNavbar,
    Accordion,
    DatePicker,
    ShipmentAddressField,
    AddressForm,
    ConfirmModal,
    SelectComponent
  },
  directives: {
    mask
  },
  data() {
    return {
      typePage:"",
      searchingOrderAllItems: false,
      searchingOrderServiceItems: false,
      occupancyRate: 0,
      loadSaveOrder: false,
      loadPostOrder: false,
      loadCancelOrder: false,
      loadApproveOrder: false,

      loadingItems: false,
      showEditQuantity: 0,
      showEditArea: 0,
      showEditVolume: 0,
      showEditCountServiceItem: 0,
      showEditCountServiceId: 0,

      showPriceTypes: 0,
      showModalAddItemsService: false,
      showModalAddItems: false,
      showModalAddService: false,
      textForSearchItemsAdd: '',
      textForSearchItemsAddService: '',
      minDate: {},
      currentDateShipment: new Date(),
      objectOrderDraft: {},
      selectedCarsService: [],
      selectedCarsServiceWithObj: [],
      selectedItems: [],
      selectedItemsDel: [],
      selectedServices: [],
      selectedServicesDel: [],
      orderNum: '',
      allServices: [],
      originOrderAllItems: [],
      orderAllItems: [],
      orderCarsService: [],
      orderAllItemsSearch: [],
      addOrderAllItems: [],
      addOrderAllCarsService: [],
      addAllServices: [],
      serviceItemsForNewOrder: [],
      openBlockServices: true,
      flagGetService: false,
      flagGetItems: false,
      selectService: 0,
      errorText: "",
      successText: "",
      errorTextItems: "",

      orderServices: [],
      isReady: false,
      allRelatedOrders: [],
      objectOrder: {
        creationDate: "",
        orderStatus: "",
        division: "", // выбор
        orderNumberClient: "", // вручную
        shipmentMethod: "", // выбор
        region: "", // выбор
        shipmentAddress: "", // вручную
        shipmentAddress2: "", // вручную
        addInformation: "", // вручную
        consignee: null,
        inn: null,
        cars: [
          {
            carId: 1,
            summ: 0,
            orderWeight: 0,
            occupancyRate: 0,
            shipmentDate: null,
            relatedOrders: [],
            items: []
          }
        ],
        items: [],
        services: [],
        load: null
      },
      idGetOrder: "",
      getAddons: false,
      searchTimeout: null,
      createdDate: "",
      incorrectInn: false,
      incorrectAddress: false,
      selectedAddress: false,
      showFormAddAddress: false,
      haveNewAddress: false,
      orderError: "",
      currentCarId: 0,
      selectedRelated: [],
      carsHaveEmptyItems: true,
      clearSelected: false,
      // Чаты
      files: [],
      errorMessage: "",
      maxFiles: 10,
      maxFilesSize: 100,
      uniqueFiles: new Set(),
      orderMessages: [],
      sendingMessages: [],
      newMessage: "",
      userID: "",
      loadingMessages: false,
      messagesId: [],

      editCars: [],
      arrOrderServiceId: [],
      oldRelatedOrders: [],
      newAddressArrayForm: [],
      shipmentDatesByCarId: {},
      suppressCarsWatch: false,
    }
  },

  computed: {
    // Выбранные товары
    selectedItemsByCarId() {
      const rec = this.selectedItems.find(o => o.carId == this.currentCarId);
      return rec ? rec.selected : [];
    },

    toDisableBtn() {
      if(this.loadCancelOrder || this.loadApproveOrder || this.loadPostOrder || this.loadSaveOrder) {
        return true;
      } else {
        return false;
      }
    },

    itemsByCarId() {
      return new Map((this.orderAllItems ?? [])
        .map(x => [String(x.carId), x.items ?? []]));
    },

    originItemsByCarId() {
      return new Map((this.originOrderAllItems ?? [])
        .map(x => [String(x.carId), x.items ?? []]));
    },

    showFileBtn() {
      return this.isReady && this.typePage == 'view' && this.objectOrder.status != 'Черновик'
    },

  },

  async mounted() {

    if(localStorage.getItem('userID') != undefined && localStorage.getItem('userID') != '') {
      this.userID = localStorage.getItem('userID')
    }

    await this.init()

    this.scrollToBottom();

    await this.waitForElements();
    this.setupIntersectionObserver();
  },

  watch: {
    // Отследить изменение поля поиска в блоке товаров
    textForSearchItemsAdd: {
      handler(val) {
        if(!this.isEmpty(val)) {
          if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
          }

          // Проверки для красоты прелоадера
          if (val.length > 2) {
            this.searchingOrderAllItems = true
          }
          else {
            this.orderAllItems = JSON.parse(JSON.stringify(this.originOrderAllItems))
            this.searchingOrderAllItems = false
          }

          // Выполнение проверки поля и выполненя поиска с задержкой в 2 секунды
          this.searchTimeout = setTimeout(() => {
            if (val.length > 2) {
              this.checkObjectForItems(val, 'orderAllItems');
              this.searchingOrderAllItems = false
            }
          }, 1500);
        }
        else {
          this.orderAllItems = JSON.parse(JSON.stringify(this.originOrderAllItems))
        }
      },
      deep: true
    },

    // Изменения получения товаров на разные регионы и типы
    'objectOrder.division': {
      async handler() {
        if(this.typePage != 'view' && this.getAddons) {
          // this.clearRelatedOrders()
          for (const car of this.objectOrder.cars) {
            await new Promise(resolve => setTimeout(resolve, 400));
            this.clearRelatedOrders(car.carId);

            if(car.shipmentDate && !this.isEmpty(this.objectOrder.region_id)) {
              this.loadingItems = true
              this.flagGetItems = false
              if(this.typePage != 'view') { 
                this.clearItems()
              }
              this.orderAllItems = []
              this.orderAllItemsSearch = []

              this.getOrderItemsAddon()
            }
          }
        }
      },
      deep: true
    },

    // Изменение способа доставки, каждый раз получаем регионы с фильтрацией по shipmentMethod
    'objectOrder.shipmentMethod': {
      async handler(val) {
        await this.getRegions(val)
        if(this.typePage != 'view' && this.getAddons) {
          for (const car of this.objectOrder.cars) {
            await new Promise(resolve => setTimeout(resolve, 400));
            this.clearRelatedOrders(car.carId);

            if(
              car.shipmentDate 
              && !this.isEmpty(this.objectOrder.region_id) 
              && !this.isEmpty(this.objectOrder.division)
            ) {
              this.getOrderItemsAddon()
            }
          }

          // Оставить только первую машину
          if(this.objectOrder.shipmentMethod == 'Самовывоз') {
            this.objectOrder.cars[0].items = [] 
            this.objectOrder.cars = [this.objectOrder.cars[0]]

            this.selectedItems = []
          } 

          this.orderAllItems = []
          this.originOrderAllItems = []
        }
      },
      deep: true
    },

    'objectOrder.region_id': {
      async handler() {
        if(this.typePage != 'view') {
          if(this.getAddons) {
            for (const car of this.objectOrder.cars) {
              await new Promise(resolve => setTimeout(resolve, 400));
              this.clearRelatedOrders(car.carId);

              if(
                car.shipmentDate 
                && !this.isEmpty(this.objectOrder.division) 
                && !this.isEmpty(this.objectOrder.shipmentMethod)
              ) {
                this.loadingItems = true
                this.flagGetItems = false
                if(this.typePage != 'view') {
                  this.clearItems()
                }
                this.orderAllItems = []
                this.orderAllItemsSearch = []

                this.getOrderItemsAddon()
              }
            }
          }

          if(this.isEmpty(this.objectOrder.region_id)) {
            this.objectOrder.cars[0].items = []
            this.objectOrder.cars = [this.objectOrder.cars[0]]

            this.selectedItems = []
          } else {
            // Получить список доступных связанных заказов
            await this.getRelatedOrders(this.objectOrder.region_id)
          }
        }
      },
      deep: true
    },

    'messagesId': {
      async handler() {
        for(let id of this.messagesId) {
          let message = this.orderMessages.filter(mess => mess.id == id)
          if(message && this.isEmpty(message[0].viewStatus)) {  
            // Запрос на обновление сообщения
            let objForRequest = {"view_status": 1};
            let res = await GlobalRequest.request("/order-message/update/" + id, "POST", objForRequest)
            if(!res.success) {
              console.log("Ошибка при обновлении статуса сообщения")
              console.log(res)
            }
            else {
              message[0].viewStatus = 1;
              // console.log("Сообщение с ID=" + id + " прочитано")
            }
          }
        }
      },
      deep: true
    },

    // Следим за изменениями в объекте машин товаров
    'objectOrder.cars': {
      async handler(newValueCar) {
        if(newValueCar && this.typePage != "view") {

          if (!Array.isArray(newValueCar)) return;
          if (this.suppressCarsWatch) return;

          this.suppressCarsWatch = true;

          try {
            // Проверка количества товаров в машине
            let carItems = newValueCar.filter(car => car.items.length < 1)
            if(carItems.length > 0) {
              this.carsHaveEmptyItems = true
            } else {
              this.carsHaveEmptyItems = false
            }

            // Проверка на наличие заказов в relatedOrders
            const relatedCarIds = newValueCar
              .filter(car => car.relatedOrders && car.relatedOrders.length > 0) // Фильтруем машины с связанными заказами
              .map(car => car.carId); // Извлекаем carId

            const hasRelatedOrders = relatedCarIds.length > 0; // Есть ли связанные заказы

            // Если есть связанные зказы в машине, то добавляем услугу и id машины в эту услугу
            // Иначе удаляем из услуги и если она остается пустая, то ее саму тоже удаляем

            // Выбираем нужную услугу из всех получееных, выполняем действия, если эта услуга есть в списке
            let service = this.orderServices.find(service => service.title == "Доставка на несколько адресов");
            if(service) {
              if (hasRelatedOrders) {

                // Добавлять услугу, если она еще не добавлена
                if (!this.selectedServices.includes(service.id)) {
                  this.selectedServices.push(service.id)
                  this.saveService()
                }

                this.orderCarsService = []
                for(let car of this.objectOrder.cars) {
                  this.orderCarsService.push(car.carId)
                }

                // Добавить id машин в услуги
                for(let id of relatedCarIds) {
                  this.addCar(id)
                }
                this.saveCarsService(service.id)

              } else {
                this.selectedServices = this.selectedServices.filter(id => id !== service.id);
                this.saveService()
              }
            }

            const changedIds = [];

            // Отслеживание изменения количества товара
            newValueCar.forEach((car) => {
              car.items.forEach((item) => {
                if(item.quantity <= 0) {
                  item.quantity = 1
                }
              })

              const sig = car.shipmentDate;
              const prev = this.shipmentDatesByCarId[car.carId];

              // если дата у этой машины изменилась — запомним и поставим на загрузку
              if (prev != sig) {
                this.shipmentDatesByCarId[car.carId] = sig;
                if (sig) changedIds.push(car.carId);
              }

            });

            if (
              changedIds.length
              && !this.isEmpty(this.objectOrder.division) 
              && !this.isEmpty(this.objectOrder.shipmentMethod) 
              && !this.isEmpty(this.objectOrder.region_id)
            ) {
              // точечно грузим только изменившиеся машины
              for (const id of changedIds) {
                await this.getOrderItemsAddon(id);
              }
            }

            let clearRelatedCars = newValueCar.filter(car => car.relatedOrders.length > 0 && (car.occupancyRate <= 0 || car.occupancyRate >= 100))
            clearRelatedCars.forEach((car) => {
              this.clearRelatedOrders(car.carId)
            });

            // Рассчитывать шапку при каждом изменении в машине
            this.calculateOrder()
          } finally {
            this.suppressCarsWatch = false;
          }
        }
      },
      deep: true
    },

  },

  methods: {

    async init() {
      this.isReady = false
      this.typePage = this.$route.query.type
      this.idGetOrder = this.$route.query.id

      await this.getObjOrderDraft()
      if(this.isEmpty(this.objectOrderDraft)) {
        this.errorText = "Данные для предзаполнения не были получены"
      }
      else {
        if(this.isEmpty(this.objectOrderDraft.contrAgent)) {
          this.errorText = "Для создания заказа необходимо добавить юридическое лицо, которое будет производить оплату. Обратитесь в клиентский сервис за помощью."
        }
        else {
          const values = Object.values(this.objectOrderDraft.contrAgent);
          this.objectOrder.contrAgent = values[0]

          await this.getOrderServices()
          if(this.isEmpty(this.orderServices)) {
            this.errorText = "Доступные услуги не были получены"
          }
        }
      }

      // Объект даты для доставки, нельзя выбрать сегодня и завтра
      let minDate = this.currentDateShipment.setDate(this.currentDateShipment.getDate() + 2)
      let objDate = {}
      objDate.to = new Date(minDate)
      this.minDate = objDate 

      if(!this.isEmpty(this.idGetOrder)) {
        await this.getOrderObj()
      }

      this.getMessages()

      this.isReady = true
    },

    // Заполнить тип продукции, способ доставки и регион
    async selectOrderValues() {
      this.objectOrder.division = this.dataBasedOnKP.division
      this.objectOrder.region_id = this.dataBasedOnKP.region

      // Ищем соответствующий тип доставки по региону (изменилась логика, теперь на самовывоз тоже появился регион)
      for(let shipmentMethod of this.objectOrderDraft.deliveryMethods) {
        let res = await GlobalRequest.request("/region/list?shipmentMethod=" + shipmentMethod, "GET")
        if(res.success) {
          let region = res.data.find(region => region.id == this.objectOrder.region_id);
          if (region) {
            this.objectOrder.shipmentMethod = shipmentMethod;
            break; // Выходим из цикла, если регион найден
          }
        }
      }
    },
    
    formatDMYHI(input) {
      const d = new Date(input);
      if (isNaN(d)) return ''; // защита
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()}`;
    },
    
    // Получить заказ
    async getOrderObj() {
      this.arrOrderServiceId = []
      let res = await GlobalRequest.request("/order/" + this.idGetOrder, "GET")
      if(res.success)
        this.objectOrder = res.data
      else
        this.objectOrder = {}

      if(!this.isEmptyObj(this.objectOrder)) {
        this.selectedAddress = this.objectOrder.shipmentAddress
        this.errorText = ""

        this.orderNum = this.objectOrder.orderNumber

        // Группа заказов
        let arrayGroupOrders = []
        for(let ord of this.objectOrder.relatedOrdersS) {
          let obj = {}
          obj.id = ord.id
          obj.name = ord.orderNumberClient + " " + parseInt(ord.occupancyRate) + "%"
          obj.occupancyRate = ord.occupancyRate
          obj.shipmentDate = ord.shipmentDate
          obj.status = ord.status
          obj.carId = 1
          arrayGroupOrders.push(obj)
        }

        this.objectOrder.groupOrders = arrayGroupOrders

        if(this.objectOrder.region)
          this.objectOrder.region_id = this.objectOrder.region.id
        else
          this.objectOrder.region_id = null

        this.createdDate = this.objectOrder.created
        this.objectOrder.created = this.formatDate(this.objectOrder.created)

        if(this.typePage == "view") {

          this.objectOrder.cars = [
            {
              carId: 1,
              summ: 0,
              orderWeight: 0,
              occupancyRate: 0,
              shipmentDate: null,
              relatedOrders: [],
              items: []
            }
          ]
          if(!this.isEmpty(this.objectOrder.shipmentDate)) {
            let parts = this.objectOrder.shipmentDate.split('.');

            // Преобразуем строки в числа
            let day = parseInt(parts[0], 10);
            let month = parseInt(parts[1], 10) - 1; // Месяцы в JavaScript начинаются с 0
            let year = parseInt(parts[2], 10);
            this.objectOrder.cars[0].shipmentDate = new Date(year, month, day);
          }

          // Заполнить товрами машину
          let carItems = JSON.parse(JSON.stringify(this.objectOrder.items))
          this.objectOrder.cars[0].items = carItems

          // Выводим 1 машину и добавляем все полученные услуги к ней
          for( let service of this.objectOrder.services) {
            service.cars = [
              {
                "id": 1
              }
            ]
          }

          let arrayRelatedOrders = []
          for(let ord of this.objectOrder.relatedOrdersD) {
            let obj = {}
            obj.id = ord.id
            obj.name = ord.orderNumberClient + " " + parseInt(ord.occupancyRate) + "%"
            obj.occupancyRate = ord.occupancyRate
            obj.shipmentDate = ord.shipmentDate
            obj.status = ord.status
            obj.carId = 1
            arrayRelatedOrders.push(obj)
          }

          this.allRelatedOrders = arrayRelatedOrders
          this.objectOrder.cars[0].relatedOrders = arrayRelatedOrders;


        } else {
          await this.getGroupOrders()
          if(this.editCars) {
            this.objectOrder.cars = this.editCars
          }
        }

        // Массив с выборкой товаров
        // let objectSelectedCar = {}
        // objectSelectedCar.carId = 1
        // objectSelectedCar.selected = []
        // this.selectedItems.push(objectSelectedCar) 

        let index = 1
        
        for (let car of this.objectOrder.cars) {
          let objTempOrderServiceId = {}
          objTempOrderServiceId.carId = index
          car.carId = index
          if(this.typePage != "view") {
            if(!this.isEmpty(car.shipmentDate)) {
              let parts = car.shipmentDate.split('.');

              // Преобразуем строки в числа
              let day = parseInt(parts[0], 10);
              let month = parseInt(parts[1], 10) - 1; // Месяцы в JavaScript начинаются с 0
              let year = parseInt(parts[2], 10);
              car.shipmentDate = new Date(year, month, day);
            }
          }

          let newItems = []
          for(let index in car.items) {
            newItems.push(car.items[index])
          }

          car.items = newItems

          for(let item of car.items) {
            item.rowId = this.generateRowId();

            let obj = {}
            obj.type = item.priceType
            obj.price = item.itemPrice
            obj.title = item.priceTypeTitle

            item.selectedPriceType = obj
            // console.log(item.selectedPriceType)
            
            item.priceTypes = item.availablePriceTypes

            item.originId = item.id
            item.id = item.itemId
            
            delete item.itemId

            // let carSelectedItem = this.selectedItems.find(obj => obj.carId == car.carId);
            // if(carSelectedItem) {
            //   console.log(carSelectedItem)
            //   carSelectedItem.selected.push(item.id)
            // }
            
            // Посчитать
            this.calculateQuantity(item)
          }

          if(this.typePage != "view") {
            let arrayServ = []
            for(let index in car.services) {
              arrayServ.push(car.services[index])
            }
            car.services = arrayServ

            // Заполнить услуги addCar(car)
            if(car.services) {
              // let obj = {}
              for( let service of this.objectOrder.services) {
                if(car.services.some(serv => serv.id == service.id)) {
                  if (!service.cars) {
                    // Если нет, создаем его пустым массивом
                    service.cars = [];
                  }
                  let objS = {id: index}
                  service.cars.push(objS)
                }
              }
            }

            let arrayTempOrderServiceId = []
            for(let ser of car.services) {
              let ob = {}
              ob.serviceId = ser.id
              ob.orderServiceId = ser.orderServiceId
              arrayTempOrderServiceId.push(ob)
            }
            objTempOrderServiceId.services = arrayTempOrderServiceId

            car.relatedOrders = []

            for(let ord of car.relatedOrdersD) {
              ord.carId = index
              ord.name = ord.orderNumberClient + " " + parseInt(ord.occupancyRate) + "%"

              // Добавить к массиву со всеми заказами 
              this.oldRelatedOrders.push(ord)
              car.relatedOrders.push(ord)
            }

          }

          this.arrOrderServiceId.push(objTempOrderServiceId)
          index = index + 1
        }

        delete this.objectOrder.items

        this.isReady = true
        this.orderCarsService = this.objectOrder.cars

        this.calculateOrder()
      }
      else {
        this.errorText = "Заказ не был получен"
      }
    },

    async getGroupOrders() {
      let res = await GlobalRequest.request("/order/list/related/" + this.$route.query.id + "/S ", "GET")
      if(res.success) {
        this.errorText = ""
        this.editCars = res.data
        
      } else {
        this.errorText = "Не удалось получить группу заказов"
      }
    },

    // Изменение желаемой даты отгрузки
    updateShipmentDate(car) {
      this.clearRelatedOrders(car.carId)
    },

    // Активность полей ввода
    getActive() {
      if(this.typePage != 'view' && this.objectOrder.shipmentMethod == 'Самовывоз') {
        this.objectOrder.shipmentAddress = ''
      }
      if(this.typePage == 'view') {
        return 'disableField'
      }
    },

    async clearRelatedOrders(id) {
      const carActive = this.objectOrder.cars.find(car => car.carId == id);

      if (!carActive) {
        return;
      }

      if (!Array.isArray(carActive.relatedOrders) || carActive.relatedOrders.length === 0) {
        return;
      }

      this.clearSelected = id;
      carActive.relatedOrders = [];

      setTimeout(() => {
        if (this.clearSelected === id) {
          this.clearSelected = false;
        }
      }, 300);
    },

    // Получение регионов с фильтрацией по методу доставки
    async getRegions(shipmentMethod) {
      let res = await GlobalRequest.request("/region/list?shipmentMethod=" + shipmentMethod, "GET")
      if(res.success)
        this.objectOrderDraft.regions = res.data
      else
        this.objectOrderDraft.regions = []

        if(!this.objectOrderDraft.regions.some(region => region.id === this.objectOrder.region_id)) {
          this.objectOrder.region_id = ''
        }
    },

    togglePriceTypes(car, item) {
      if(item.priceTypes) {
        this.showPriceTypes = car.carId + "-" + item.rowId
      }
    },

    // Закрыть модалку
    closeModal(typeModal) {
      if ( typeModal == "addItems" ) {
        this.showModalAddItems = false;
      }
      else if ( typeModal == "addItemsService" ) {
        this.showModalAddItemsService = false;
        this.selectedCarsService = []
      }
      
      this.showModalAddService = false;
      this.showPriceTypes = 0;

      this.showFormAddAddress = false
    },

    // Добавить/Удалить id заголовка для таблицы в массив. Объекты: товары, товары в услугах, услуги
    addItem(itemId, objectItems) {
      let obj = objectItems.find(o => o.carId == this.currentCarId)

      // если объекта для машины нет — создаём
      if (!obj) {
        obj = {
          carId: this.currentCarId,
          selected: []
        }
        objectItems.push(obj)
      }

      const idx = obj.selected.indexOf(itemId)

      if (idx !== -1) {
        obj.selected.splice(idx, 1)
      } else {
        obj.selected.push(itemId)
      }

      // let carItems = objectItems.find(obj => obj.carId == this.currentCarId).selected
      // if(carItems.includes(itemId)) {
      //   carItems = carItems.filter(element => element != itemId);
      // } else {
      //   carItems.push(itemId);
      // }
      // objectItems.find(obj => obj.carId == this.currentCarId).selected = carItems
    },

    addService(serviceId) {
      if(this.selectedServices.includes(serviceId)) {
        this.selectedServices = this.selectedServices.filter(element => element != serviceId);
      }
      else
        this.selectedServices.push(serviceId);
    },

    addCar(car) {
      if(this.selectedCarsService.includes(car)) {
        this.selectedCarsService = this.selectedCarsService.filter(element => element != car)
      }
      else {
        this.selectedCarsService.push(car);
      }
    },

    // Выбрать все чекбоксы или очистить 
    selectOrderAllItems(carId) {
      // Получаем все id всех элементов
      const itemsId = this.getCarItems(this.orderAllItems, carId).map(item => item.id);

      if(this.addOrderAllItems.includes(carId)) {
        this.addOrderAllItems = []
        
        // Удаляем только те элементы, которые относятся к текущему carId
        let itemsSelected = this.selectedItems.find(obj => obj.carId == carId).selected
        this.selectedItems.find(obj => obj.carId == carId).selected = itemsSelected.filter(id => !itemsId.includes(id));
      } else {
        // Если carId не в выбранных элементах, добавляем новые
        this.addOrderAllItems.push(carId);
        
        // Добавляем элементы в соответствующий объект в selectedItems
        const selectedObj = this.selectedItems.find(obj => obj.carId == carId);
        
        if (selectedObj) {
          // Объединяем существующие и новые выбранные элементы, убираем дубликаты
          selectedObj.selected = Array.from(new Set([...selectedObj.selected, ...itemsId]));
        } else {
          // Если объекта с этим carId нет, создаем новый
          this.selectedItems.push({
            carId: carId,
            selected: itemsId
          });
        }
      }
    },

    // Выбрать все чекбоксы или очистить 
    selectOrderAllCarsService(serviceId) {
      if(this.addOrderAllCarsService.includes(serviceId)) {
        this.addOrderAllCarsService = []
        this.selectedCarsService = []
      }
      else {
        this.addOrderAllCarsService.push(serviceId)
        for(let index in this.orderCarsService) {
          let item = this.orderCarsService[index]
          this.selectedCarsService.push(item)
        }
      }
    },

    // Выбрать все чекбоксы или очистить 
    selectAllServices() {
      if(this.addAllServices.includes("1")) {
        this.addAllServices = []
        this.selectedServices = []
      }
      else {
        this.addAllServices.push("1")
        for(let index in this.orderServices) {
          let item = this.orderServices[index]
          this.selectedServices.push(item.id)
        }
      }
    },

    // Сохранить выбранные товары для машины с товарами
    saveItems(carId) {
      // машина и выбранные ID для неё
      const orderCar = (this.objectOrder.cars || []).find(c => c.carId == carId);
      const selectedObj = (this.selectedItems || []).find(o => o.carId == carId);

      if (!orderCar || !selectedObj) return;

      const selectedIds = selectedObj.selected || [];

      // пул доступных товаров для этой машины (ИСТОЧНИК)
      const originForCar = this.getCarItems(this.originOrderAllItems, carId) || [];

      // только выбранные позиции из источника
      // const baseItems = originForCar.filter(it => selectedIds.includes(it.id));

      // подготовим новые элементы: если уже есть в машине — берём существующий,
      // иначе создаём с дефолтными полями
      // const arrayItems = [];
      // for (const it of baseItems) {
      //   const existed = (orderCar.items || []).find(x => x.id == it.id);
      //   if (existed) {
      //     arrayItems.push(existed);
      //   } else {
      //     arrayItems.push({
      //       ...it,
      //       selectedPriceType: "",
      //       itemPrice: "",
      //       priceType: "",
      //       total: "",
      //       proposalId: "",
      //       quantity: 1,
      //     });
      //   }
      // }

      // оставляем из текущих только те, что всё ещё отмечены, и добавляем новые без дублей
      // const current = orderCar.items || [];
      // const keep = current.filter(x => selectedIds.includes(x.id));
      // orderCar.items = [
      //   ...keep,
      //   ...arrayItems.filter(x => !keep.some(k => k.id == x.id)),
      // ];

      selectedIds.forEach(id => {
        const src = originForCar.find(i => i.id === id)
        if (!src) return

        // ВСЕГДА добавляем новый товар
        orderCar.items.push({
          ...JSON.parse(JSON.stringify(src)),
          
          rowId: this.generateRowId(),

          selectedPriceType: "",
          itemPrice: "",
          priceType: "",
          total: "",
          proposalId: "",
          quantity: 1,
        })
      });

      selectedObj.selected = []

      // закрыть модалку/сбросить состояние
      this.showModalAddItems = false;
      this.getAddons = true;
      this.currentCarId = 0;

      this.resetEditFields();
    },

    // Сохранить выбранные машины для блока услуг
    saveCarsService(serviceId) {
      let newArr = []
      for(let item of this.orderCarsService) {
        if(this.selectedCarsService.includes(item))
          newArr.push(item)
      }
      this.selectedCarsService = newArr

      let arrayCars = []
      // все машины
      for(let carId of this.orderCarsService) { 
        // Если в массиве id выбранных машин для услуг есть товар 
        if(this.selectedCarsService.includes(carId)) {
          // Проверка на наличие этого товара в услугах
          for (let service of this.objectOrder.services) {
            if(service.id == serviceId) { // если service равно выбранному
              if(!service.cars.some(car => car.id == carId)) {
                let obj = {}
                obj.id = carId
                arrayCars.push(obj)
              }
              else {
                if(!arrayCars.includes(carId))
                  arrayCars.push(service.cars.find(car => car.id == carId))
              }
            }
          }
        }
      }

      // дубли
      let uniqueCars = arrayCars.filter((item, index, self) =>
          index === self.findIndex((t) => (
              t.id === item.id
          ))
      );

      let jsonCars = JSON.stringify(uniqueCars)
      uniqueCars = JSON.parse(jsonCars)

      for (let service of this.objectOrder.services) {
        if (service.id === serviceId) {
            service.cars = uniqueCars;
            break; // Выход из цикла, если объект найден
        }
      }

      if(this.selectedCarsServiceWithObj.some(item => item.serviceId === this.selectService)) {
        for(let item of this.selectedCarsServiceWithObj) {
          if(item.serviceId == this.selectService)
            item.carsId = this.selectedCarsService
        }
      }
      else {
        let obj = {}
        obj.serviceId = this.selectService
        obj.carsId = this.selectedCarsService
        this.selectedCarsServiceWithObj.push(obj)
      }

      this.selectedCarsService = []
      this.showModalAddItemsService = false
    },

    // Сохранить выбранные услуги
    saveService() {
      let arrayServices = [] 

      for(let key in this.orderServices) {
        // Если массив выбранных услуг содержит id услуги
        if(this.selectedServices.includes(this.orderServices[key].id)) {

          if(!this.objectOrder.services.some(item => item.id === this.orderServices[key].id)) {
            this.orderServices[key].cars = []
            arrayServices.push(this.orderServices[key])
          }
          else {
            arrayServices.push(this.objectOrder.services.find(item => item.id === this.orderServices[key].id))
          }
        } else {
          // Удаляем выбранные машины
          this.selectedCarsServiceWithObj = this.selectedCarsServiceWithObj.filter(item => item.serviceId != this.orderServices[key].id);
        }
      }
      this.objectOrder.services = arrayServices
      this.showModalAddService = false
    },

    checkObjectForItems(val, type) { 
      let searchingStr = val.toLowerCase()

      const allItems = JSON.parse(JSON.stringify(this.originOrderAllItems))
      let allItemsForCar = this.getCarItems(allItems, this.currentCarId)

      const car = this.orderAllItems.find(x => x.carId == this.currentCarId);

      // Проверка массива с товарами на наличие подстроки а названии или артикуле 
      if( type == 'orderAllItems' && car)
        car.items = allItemsForCar.filter(item => item.name.toLowerCase().includes(searchingStr) || item.sku.toLowerCase().includes(searchingStr))
    },

    // Проверка отмеченных товаров при открытии модалки с выбором
    checkSelectedItemsInOpenModal() {
      let newSelectedItems = []

      // Текущая машина
      let currentCar = this.objectOrder.cars.find(car => car.carId == this.currentCarId)
      for(let key in currentCar.items) {
        newSelectedItems.push(currentCar.items[key].id)
      }

      const cur = this.selectedItems.find(o => o.carId == this.currentCarId);
      
      if (cur) {
        cur.selected = newSelectedItems;
      } else {
        this.selectedItems.push({ carId: this.currentCarId, selected: newSelectedItems });
      }
    },

    // Проверка отмеченных машин при открытии окна выбора для услуги
    checkSelectedCarsInOpenModal() {
      if(this.selectedCarsServiceWithObj.length > 0) {
        if(!this.isEmpty(this.selectedCarsServiceWithObj.find(serv => serv.serviceId == this.selectService))) {
          this.selectedCarsService = this.selectedCarsServiceWithObj.find(serv => serv.serviceId == this.selectService).carsId
        }
      }
      else {
        this.selectedCarsService = []
      }
    },

    // Данные для предзаполнения
    async getObjOrderDraft() {
      let res = await GlobalRequest.request("/order/draft", "GET")
      if(res.success) {
        this.orderError = ""
        this.objectOrderDraft = res.data
        this.objectOrderDraft.regions = [] // массив регионов
      } else {
        this.orderError = "Ошибка получения данных для предзаполнения заказа"
      }

      // console.log("DRAFT")
      // console.log(this.objectOrderDraft)
    },

    async getOrderServices() {
      let res = await GlobalRequest.request("/service/list", "GET")
      if(res.success) {
        this.orderServices = res.data
        this.flagGetService = true
      }

      // console.log("SERVICES")
      // console.log(this.orderServices)
    },
    
    async addOrderServices() {
      this.showModalAddService = true
    },

    // Очистить все доступные товары, при смене способа доставки и региона(по условию)
    clearItems() {
      this.orderAllItems = []
      this.originOrderAllItems = []
      this.resetEditFields()
    },

    resetEditFields() {
      this.showEditQuantity = 0
      this.showEditArea = 0
      this.showEditVolume = 0
      this.showPriceTypes = 0
    },

    // Получить товары
    // Вызов при смене региона, способа доставки и типа продукции
    async getOrderItemsAddon(idEditingCar) {
      // console.log("ADDONS")

      if(
        !this.isEmpty(this.objectOrder.contrAgent) &&
        !this.isEmpty(this.objectOrder.region_id) &&
        !this.isEmpty(this.objectOrder.division)
      ) {
        for(let car of this.objectOrder.cars || []) {
          // Если в метод передан id машины, то получаем товары только для нее, иначе для всех машин
          if(idEditingCar && idEditingCar != car.carId) continue;
          
          // Дата отгрузки машины в виде d.m.Y
          let dateNormal = this.formatDMYHI(car.shipmentDate)

          const res = await GlobalRequest.request(
            `/order/items?contrAgentId=${this.objectOrder.contrAgent.id}` +
            `&regionId=${this.objectOrder.region_id}` +
            `&division=${this.objectOrder.division}` +
            `&shipmentDate=${dateNormal}`,
            "GET"
          );

          if (!res?.success) continue;

          const nextOrigin = (this.originOrderAllItems ?? []).filter(x => x.carId != car.carId);
          nextOrigin.push({ carId: car.carId, items: res.data });
          this.originOrderAllItems = nextOrigin;

          // Если модалка сейчас открыта для этой машины — обновим рабочую копию
          if (this.showModalAddItems && this.currentCarId === car.carId) {
            this.orderAllItems = [{ carId: car.carId, items: JSON.parse(JSON.stringify(res.data)) }];
          }

          // if((!this.isEmpty(this.idGetOrder) && this.getAddons) || this.isEmpty(this.idGetOrder) ) {
            const pool = res.data || [];
            const poolById = new Map(pool.map(i => [i.id, i]));

            for (const orderNewItem of [...car.items]) {
              const ref = poolById.get(orderNewItem.id);

              if(ref) {
                const prevSelected = orderNewItem.selectedPriceType || null;
                const newPriceTypes = Array.isArray(ref.priceTypes) ? ref.priceTypes : [];

                orderNewItem.priceTypes = newPriceTypes;

                if (prevSelected) {
                  const same = newPriceTypes.find(pt =>
                    ((prevSelected.id != null && String(pt.id) == String(prevSelected.id) && pt.type == prevSelected.type)) ||
                    (pt.type === prevSelected.type && pt.title == prevSelected.title)
                  );
                  orderNewItem.selectedPriceType = same || "";
                } else {
                  orderNewItem.selectedPriceType = "";
                }
              } else {
                // нет в общем — убираем из текущей машины + из selected
                car.items = car.items.filter(i => i.id != orderNewItem.id);
                const sel = this.selectedItems.find(o => o.carId == car.carId);
                if (sel) sel.selected = sel.selected.filter(id => id != orderNewItem.id);
              }
            }

            // Подсчет позиций по количеству товаров
            car.items.forEach(item => {
              const carItems = this.getCarItems(this.originOrderAllItems, car.carId);
              const carItemIds = new Set(carItems.map(i => String(i.id)));

              if (item.quantity > 1 && carItemIds.has(String(item.id))) {
                this.calculateQuantity(item, car.carId);
              }

            });
          // }

        }

      }

      this.loadingItems = false
      this.clearSelected = false
    },

    // Показать окно с выбором товаров для блока товаров
    async getOrderItems(carId) {
      this.currentCarId = carId
      this.showModalAddItems = true
      this.flagGetItems = true
      
      this.addOrderAllItems = []
      this.textForSearchItemsAdd = ""

      const src = this.originItemsByCarId.get(String(carId)) ?? [];
      // рабочая копия для модалки — только товары текущей машины
      this.orderAllItems = [{ carId, items: JSON.parse(JSON.stringify(src)) }];

      // Синхронизация выбранных товаров с модалкой выбора товара
      // this.checkSelectedItemsInOpenModal()
    },

    // Показать окно с выбором товаров для блока услуг
    async getOrderCarsService(serviceId) {
      this.orderCarsService = []

      for(let car of this.objectOrder.cars) {
        this.orderCarsService.push(car.carId)
      }
      
      this.showModalAddItemsService = true
      this.addOrderAllCarsService = []
      this.selectService = serviceId
      this.checkSelectedCarsInOpenModal()
    },

    // Проверка на пустоту
    isEmpty(data) {
      if(data != "" && data != " " && data != 0 && data != null && data != undefined) {
        if(data.length > 0) return false
      }
      else {
        return true
      }
    },

    getPriceType(type, item) {
      item.selectedPriceType = type
      item.itemPrice = type.price
      item.priceTypeTitle = type.title
      item.priceType = type.type
      item.total = ""

      if(type.type == "proposal")
        item.proposalId = type.id
      else
        item.proposalId = null

      this.showPriceTypes = 0;
    },

    getBgPriceType(itemPS) {
      if(!itemPS.priceTypes) {
        return "gray-block-ps-type"
      }
      else {
        if(!this.isEmpty(itemPS.selectedPriceType)) {
          if(itemPS.selectedPriceType.title.includes("КП"))
            return "light-block-ps-type"
        }
      }
    },

    getItogItemSumm(item) {
      if(item.selectedPriceType == "") {
        return 0
      }
      else {
        let price = parseFloat(item.selectedPriceType.price)
        let quantity = parseInt(item.quantity)
        let itogSumm = price * quantity

        return (itogSumm).toFixed(2)
      }
    },

    // Изменить поле м2
    getEditArea(carId, rowId) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditArea = carId + "-" + rowId
    },

    getEditVolume(carId, rowId) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditVolume = carId + "-" + rowId
    },

    // поле ед
    getEditQuantity(carId, rowId) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditQuantity = carId + "-" + rowId
    },

    // При изменении ед M2 должно пересчитываться по формуле:
    // Order_Item.Area = Order_Item.Quantity * Item.Area

    // При изменении ед M3 должно пересчитываться по формуле:
    // Order_Item.Volume = Order_Item.Quantity * Item.Volume

    // При изменении ед КГ должно пересчитываться по формуле:
    // Order_Item.Weight = Order_Item.Quantity * Item.Weight

    calculateQuantity(item, carId) {
      // округляем на всякий
      item.quantity = Math.round(item.quantity)
      if(item.quantity < 1) item.quantity = 1

      // console.log(this.originOrderAllItems)

      // Получить товар в изначальном виде,как в бд для расчета
      let originItem = item
      if(this.originOrderAllItems.length > 0) {
        let itemsForCar = this.getCarItems(this.originOrderAllItems, carId)
        originItem = itemsForCar.find(elem => elem.id === item.id);
      }

      let itemArea = parseFloat(originItem.area);     
      let itemVolume = parseFloat(originItem.volume);   
      let itemWeight = parseFloat(originItem.weight);    

      // рассчет area
      item.area = (item.quantity * itemArea).toFixed(2);

      // рассчет volume
      item.volume = (item.quantity * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (item.quantity * itemWeight).toFixed(2);

      this.showEditQuantity = 0
    },

    // При изменении м2 ЕД должно пересчитываться по формуле:
    // Order_Item.Quantity = Order_Item.Area / Item.Area
    // Выводить значение с округлением до ближайшего целого числа.

    // При изменении м2 M3 должно пересчитываться по формуле:
    // Order_Item.Volume = Order_Item.Area / Item.Area * Item.Volume

    // При изменении м2 КГ должно пересчитываться по формуле:
    // Order_Item.Weight = Order_Item.Area / Item.Area * Item.Weight

    calculateArea(item, carId) { // m2
      // Получить товар в изначальном виде,как в бд для расчета
      let itemsForCar = this.getCarItems(this.originOrderAllItems, carId)
      let originItem = itemsForCar.find(elem => elem.id === item.id);
      let itemArea = parseFloat(originItem.area);     

      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного (Item.Area)
      if(parseFloat(item.area) < itemArea)
        item.area = itemArea
      else
        item.area = (Math.round(item.area / itemArea) * itemArea).toFixed(2);

      let orderItemArea = parseFloat(item.area);
      let itemVolume = parseFloat(originItem.volume); 
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity  
      item.quantity = Math.round(orderItemArea / itemArea);

      // рассчет volume  
      item.volume = (orderItemArea / itemArea * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (orderItemArea / itemArea * itemWeight).toFixed(2);

      this.showEditArea = 0
    },

    // При изменении м3 ЕД должно пересчитываться по формуле:
    // Order_Item.Quantity = Order_Item.Volume / Item.Volume
    // Выводить значение с округлением до ближайшего целого числа.

    // При изменении м3 М2 должно пересчитываться по формуле:
    // Order_Item.Area = Order_Item.Volume / Item.Volume * Item.Area

    // При изменении м3 КГ должно пересчитываться по формуле:
    // Order_Item.Weight = Order_Item.Volume / Item.Volume * Item.Weight

    calculateVolume(item, carId) { // m3
      // Получить товар в изначальном виде,как в бд для расчета
      let itemsForCar = this.getCarItems(this.originOrderAllItems, carId)
      let originItem = itemsForCar.find(elem => elem.id === item.id);
      let itemVolume = parseFloat(originItem.volume);

      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного Item.Volume
      if(parseFloat(item.volume) < itemVolume)
        item.volume = itemVolume
      else
        item.volume = (Math.round(item.volume / itemVolume) * itemVolume).toFixed(2);

      let orderItemVolume = parseFloat(item.volume);
      let itemArea = parseFloat(originItem.area);
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity
      item.quantity = Math.round(orderItemVolume / itemVolume);

      // рассчет area
      item.area = (orderItemVolume / itemVolume * itemArea).toFixed(2);

      // рассчет weight
      item.weight = (orderItemVolume / itemVolume * itemWeight).toFixed(2);

      this.showEditVolume = 0
    },

    // Проверка на количество штук, чтобы не превышало допустимого значения
    checkCountServiceItem(item) {
      // округляем на всякий
      item.quantity = Math.round(item.quantity)
      if(item.quantity < 0 || item.quantity == 0) item.quantity = 1

      let objectOrderItem = this.objectOrder.items.find(elem => elem.id == item.id)
      if(item.quantity > parseInt(objectOrderItem.quantity)) 
        item.quantity = parseInt(objectOrderItem.quantity)

      this.showEditCountServiceItem = 0
      this.showEditCountServiceId = 0
    },

    setItemVolume(item, newValue) {
      item.volume = newValue
    },

    flagEditFields(flag) {
      if(flag) return false
      else return true
    },

    // Удалить товары из машины
    delSelectedItems(carId) {
      // Получаем выбранные элементы для текущей машины
      const carSelectedItem = this.selectedItems.find(obj => obj.carId == carId);
      const carOrderItem = this.objectOrder.cars.find(car => car.carId == carId);

      // Проверяем, есть ли удаляемые элементы для текущего carId
      const itemsToDelete = this.selectedItemsDel[carId] || []; // Получаем массив по carId или пустой массив, если такого нет

      if (carSelectedItem) {
        // Обновляем массив selected, фильтруя удаляемые элементы
        carSelectedItem.selected = carSelectedItem.selected.filter(
          item => !itemsToDelete.includes(item) // Здесь item — это идентификатор товара
        );
      }

      if (carOrderItem) {
        // Обновляем массив items, фильтруя удаляемые элементы
        carOrderItem.items = carOrderItem.items.filter(
          item => !itemsToDelete.includes(item.rowId) // Здесь item.id — это идентификатор товара
        );
      }

      // Сбрасываем удаленные элементы после процессов обновления
      this.addOrderAllItems = [];
      this.selectedItemsDel = {};
    },

    delSelectedService() {
      this.selectedServices = this.selectedServices.filter(item => !this.selectedServicesDel.includes(item));
      this.selectedCarsService = []
      this.objectOrder.services = this.objectOrder.services.filter(service => !this.selectedServicesDel.includes(service.id));

      for(let serviceId of this.selectedServicesDel) {
        for(let car of this.selectedCarsServiceWithObj) {
          if(car.serviceId == serviceId) {
            car.carsId = []
          }
        }
      }

      this.addAllServices = []
      this.selectedServicesDel = []
    },

    // Шапка блока: рассчитывается только по нажатию на кнопку Рассчитать, Сохранить и Разместить в Блоке Действий

    calculateOrder() { // рассчет шапки
      for(let car of this.objectOrder.cars) {
        // вес
        let totalWeight = 0;
        for (let item of car.items) {
            let itemWeight = parseFloat(item.weight);
            totalWeight = totalWeight + itemWeight;
        }
        car.orderWeight = totalWeight.toFixed(2);

        // Процент загрузки
        let loadPercent = 0;

        for (let item of car.items) {
          const quantity = parseFloat(item.quantity) || 0;
          const packingDensity = parseFloat(item.packingDensity) || 0;

          if (quantity > 0 && packingDensity > 0) {
            loadPercent += quantity / packingDensity * 100;
          }
        }

        loadPercent = Math.ceil(loadPercent);

        if(isNaN(loadPercent)) {
          this.occupancyRate = 0
          car.occupancyRate = 0;
        }
        else {
          this.occupancyRate = loadPercent
          car.occupancyRate = loadPercent;
        }

        // Общая сумма
        let totalSumm = 0;
        for (let item of car.items) {
          let itemSumm = 0

          if(!this.isEmpty(item.selectedPriceType)) {
            itemSumm = parseInt(item.quantity) * parseFloat(item.selectedPriceType.price);
          }

          item.total = itemSumm.toFixed(2);
            
          totalSumm = totalSumm + itemSumm;
        }

        car.summ = totalSumm.toFixed(2);
        car.total = totalSumm.toFixed(2);
      }
        
      if(this.typePage != "view") {
        // Добавить услугу за неполную загрузку машины, если есть
        this.checkAddServiceCar()
      }
    },

    isArrayOfNumbers(arr) {
      return Array.isArray(arr) && arr.every(item => typeof item === 'number');
    },

    checkAddServiceCar() {
      let carsArrayToService = []

      for (let car of this.objectOrder.cars) {
        let relatedOrdersArray = (car.relatedOrders || []).map(order => {
          if (typeof order === 'object') {
            return order.id;
          }

          return order;
        });

        let totalOccupancyRate = this.allRelatedOrders
          .filter(order => relatedOrdersArray.includes(order.id))  // Фильтруем заказы
          .reduce((total, order) => total + parseInt(order.occupancyRate || 0), 0);  // Суммируем occupancyRate

        let totalSummOccupancyRate = totalOccupancyRate + parseInt(car.occupancyRate || 0)

        // Если общая загрузка машины < 100%
        if (totalSummOccupancyRate < 100) {
          carsArrayToService.push(car.carId)
        }
      }

      // Добавление услуги
      // Выбираем нужную услугу из всех получееных, выполняем действия, если эта услуга есть в списке
      let service = this.orderServices.find(service => service.title == "Доплата за неполную загрузку машины");
      
      if (!service) {
        return;
      }

      if (carsArrayToService.length === 0) {
        this.selectedServices = this.selectedServices.filter(id => id != service.id)

        this.objectOrder.services = this.objectOrder.services.filter(
          item => item.id != service.id
        )

        this.selectedCarsServiceWithObj = this.selectedCarsServiceWithObj.filter(
          item => item.serviceId != service.id
        )

        return;
      }

      if (!this.selectedServices.includes(service.id)) {
        this.selectedServices.push(service.id)
      }

      let currentService = this.objectOrder.services.find(item => item.id == service.id)

      if (!currentService) {
        currentService = JSON.parse(JSON.stringify(service))
        currentService.cars = []
        this.objectOrder.services.push(currentService)
      }

      currentService.cars = carsArrayToService.map(carId => ({
        id: carId
      }))

      let selectedServiceCars = this.selectedCarsServiceWithObj.find(
        item => item.serviceId == service.id
      )

      if (selectedServiceCars) {
        selectedServiceCars.carsId = [...carsArrayToService]
      } else {
        this.selectedCarsServiceWithObj.push({
          serviceId: service.id,
          carsId: [...carsArrayToService]
        })
      }
    },

    formatDate(data) {
      let initialDate = new Date(data);
        let day = ("0" + initialDate.getDate()).slice(-2);
        let month = ("0" + (initialDate.getMonth() + 1)).slice(-2);
        let year = initialDate.getFullYear();

      return `${day}.${month}.${year}`
    },

    timezoneDate(data) {
      const date = new Date(data)
      
      // Получаем текущие компоненты даты
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      // Получаем смещение в минутах от UTC
      const timezoneOffsetInMinutes = date.getTimezoneOffset();
      const absOffset = Math.abs(timezoneOffsetInMinutes);
      const offsetHours = String(Math.floor(absOffset / 60)).padStart(2, '0');
      const offsetMinutes = String(absOffset % 60).padStart(2, '0');
      const sign = timezoneOffsetInMinutes > 0 ? '-' : '+';
      
      // Форматируем смещение
      const timezoneOffset = `${sign}${offsetHours}:${offsetMinutes}`;

      // Форматируем дату в нужный формат
      const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneOffset}`;

      // console.log(formattedDate);

      return formattedDate;
    },

    addinfo() {
      this.objectOrder.modified = this.formatDate(new Date())
      // дата создания
      // console.log(this.objectOrderDraft.creationDate)
    },

    getCarShipmentDate(car) {
      let carDate = null
      if(!this.isEmpty(car.shipmentDate)) {
        let dateShipment = car.shipmentDate
        // console.log("88888888888")
        // console.log(dateShipment)
        // console.log(this.formatDate(dateShipment))
        carDate = this.formatDate(dateShipment)
      }
      return carDate
    },

    checkErrors() {
      this.errorText = ""
      this.incorrectInn = false
      this.incorrectAddress = false

      // Флаг наличия ошибок в машинах с товарами
      let carsHaveError = false
      let textCarsError = ""

      outerLoop: // Метка для выхода из обоих циклов
      for (let car of this.objectOrder.cars) {
        // console.log(car);
        // Если хоть в одной машине нет товаров
        // if(car.items.length == 0) {
        //   textCarsError = "Заполните товары во всех машинах"
        //   break outerLoop;
        // }

        // Если хоть в одной машине не заполнена дата отгрузки
        // if(this.isEmpty(car.shipmentDate) || this.getCarShipmentDate(car) == "01.01.3000") {
        //   textCarsError = "Заполните желаемую дату отгрузки во всех машинах"
        //   break outerLoop;
        // }

        if(car.items.length > 0) {
          for (let item of car.items) {
            if(this.isEmpty(item.selectedPriceType)) {
              // Проверка выбора типа цены
              textCarsError = "Заполните виды цен на все товары"
              break outerLoop;
            }
          }
        }
      }

      if(!this.isEmpty(textCarsError)) {
        carsHaveError = true // ошибки в машинах есть
      }

      if(carsHaveError) this.errorText = textCarsError
      else if(this.isEmpty(this.objectOrder.contrAgent)) this.errorText = "Заполните контрагента"
      else if(this.isEmpty(this.objectOrder.orderNumberClient)) this.errorText = "Заполните номер заказа клиента"
      else if(this.isEmpty(this.objectOrder.division)) this.errorText = "Заполните тип продукции"
      else if(this.isEmpty(this.objectOrder.shipmentMethod)) this.errorText = "Заполните способ доставки"

      else if(this.objectOrder.shipmentMethod == "Доставка" && (this.selectedAddress != this.objectOrder.shipmentAddress)) {
        this.errorText = "Выберите адрес доставки из предложенных вариантов или заполните форму"
        this.incorrectAddress= true;
      }

      // else if(this.isEmpty(this.objectOrder.consignee)) this.errorText = "Заполните грузополучателя"
      // else if(this.isEmpty(this.objectOrder.inn)) this.errorText = "Заполните ИНН"
      else if(!this.isEmpty(this.objectOrder.inn)) {
        if(this.objectOrder.inn.length < 10 || this.objectOrder.inn.length == 11) {
          this.errorText = "Некорректный ИНН.  Для юридического лица - 10 цифр, для ИП - 12 цифр"
          this.incorrectInn = true;
        } else {
          this.errorText = ""
          this.incorrectInn = false;
        }
      }
      
      else {
        this.errorText = ""
        this.incorrectInn = false;
        this.incorrectAddress= false;
      }
    },

    // Объект для сохранения заказа
    getObjForSave() {
      let objForRequest = {}
        if(!this.isEmpty(this.idGetOrder)) objForRequest.id = this.objectOrder.id
        // objForRequest.id = this.idGetOrder
        objForRequest.status = this.objectOrder.status
        objForRequest.created = this.createdDate
        objForRequest.modified = this.timezoneDate(new Date())

        if(this.isEmpty(this.objectOrder.region_id))
          objForRequest.region_id = null
        else
          objForRequest.region_id = this.objectOrder.region_id

        objForRequest.order_number_client = this.objectOrder.orderNumberClient
        objForRequest.company_id = this.objectOrder.contrAgent.id
        objForRequest.shipment_method = this.objectOrder.shipmentMethod
        objForRequest.shipment_address = this.objectOrder.shipmentAddress
        objForRequest.add_information = this.objectOrder.addInformation
        objForRequest.consignee = this.objectOrder.consignee
        // group_number
        // date_adjustments
        // objForRequest.date_adjustments = 1
        objForRequest.division = this.objectOrder.division
        objForRequest.inn = this.objectOrder.inn

        let objCars = []
        // Заполнить машины
        for (let car of this.objectOrder.cars) {
          let objCar = {}
          // if(!this.isEmpty(this.idGetOrder)) objForRequest.id = this.objectOrder.id
          // obj.order_id = .. id заказа переехал
          objCar.order_id = car.id // id машины
          objCar.car_id = car.carId // id машины
          // objCar.shipment_date = car.shipmentDate // дата отгрузки
          objCar.shipment_date = this.getCarShipmentDate(car) // дата отгрузки

          let relatedOrdersArray = car.relatedOrders.map(c => c.id) // 7
          if(this.isArrayOfNumbers(car.relatedOrders)) {
            relatedOrdersArray = car.relatedOrders
          }

          objCar.related_orders = relatedOrdersArray // связанные заказы
          // objCar.total = car.total // Сумма стоимости товаров
          // objCar.order_weight = car.orderWeight // Сумма стоимости товаров

          if(car.items.length < 1) {
            objCar.total = null
            objCar.order_weight = null
          } else {
            objCar.total = car.total // Сумма стоимости товаров
            objCar.order_weight = car.orderWeight // Сумма стоимости товаров
          }
          
          // Загрузка машины
          if(car.occupancyRate == 0 || this.isEmpty(car.occupancyRate)) {
            objCar.occupancy_rate = null
          } else {
            objCar.occupancy_rate = (car.occupancyRate).toString()
          }

          let itemsArr = []
          for (let item of car.items) {
            let objItem = {}

            if(!this.isEmpty(this.idGetOrder)) {
              objItem.id = item.originId
              objItem.item_id = item.id
            }

            objItem.item_id = item.id
            objItem.price_type_title = item.priceTypeTitle
            objItem.item_price = item.itemPrice
            objItem.price_type = item.priceType
            objItem.quantity = item.quantity
            objItem.total = item.total
            // total_and_service
            // objItem.total_and_service = "1"
            objItem.proposal_id = item.proposalId
            itemsArr.push(objItem)
          }
          objCar.items = itemsArr // массив с товарами
          objCars.push(objCar)
        }
        objForRequest.cars = objCars

        // Заполнить услуги
        let newServicesFormat = this.objectOrder.services.flatMap(service => 
          service.cars.map(car => ({
            id: service.id,
            car_id: car.id
            // order_service_id: car.id
          }))
        );

        objForRequest.services = newServicesFormat

        // Заполнить id услуг по бд
        objForRequest.services.forEach(service => {
          // Находим соответствующий объект в arrOrderServiceId по car_id и id
          const foundCar = this.arrOrderServiceId.find(car => car.carId === service.car_id);
          
          if (foundCar) {
            const foundService = foundCar.services.find(s => s.serviceId === service.id);
            
            if (foundService) {
              // Если нашли соответствующий orderServiceId, добавляем его в объект
              service.order_service_id = foundService.orderServiceId;
            }
          }
        });

        // console.log(this.arrOrderServiceId)
        // console.log(this.objectOrder)
        // console.log(objForRequest)
        return objForRequest
    },

    // Провека загрузки машин < 100%
    checkErrorsOccupancyRate() {
      let carErrorOccupancyRate = false

      // проверяем загрузку только для доставки
      if(this.objectOrder.shipmentMethod != 'Самовывоз') {
        // console.log(this.allRelatedOrders)
        for(let car of this.objectOrder.cars) {
          let relatedOrdersArray = car.relatedOrders.map(c => c.id) // 7
          if(this.isArrayOfNumbers(car.relatedOrders)) {
            relatedOrdersArray = car.relatedOrders
          }

          let totalOccupancyRate = this.allRelatedOrders
          .filter(order => relatedOrdersArray.includes(order.id))  // Фильтруем заказы
          .reduce((total, order) => total + parseInt(order.occupancyRate), 0);  // Суммируем occupancyRate

          let totalSummOccupancyRate = totalOccupancyRate + parseInt(car.occupancyRate)
          // console.log(totalSummOccupancyRate)
          // console.log(car.occupancyRate)
          // console.log(relatedOrdersArray)

          if(totalSummOccupancyRate > 100) {
            carErrorOccupancyRate = car.carId
            break;
          }

        }
      }

      // console.log("Ошибка загрузки в машине №" + carErrorOccupancyRate)
      return carErrorOccupancyRate
    },

    async saveOrder() { // рассчет шапки
      this.addinfo() 

      this.checkErrors()
      if(this.errorText == "") {
        this.loadSaveOrder = true
        this.calculateOrder()

        // Получаем id машины с ошибкой загрузки > 100%
        let errorCar = this.checkErrorsOccupancyRate()

        // Если загрузка всех машин <= 100%, то отправляем на сохранение, иначе ошибка
        if(!errorCar) {

          if(this.haveNewAddress && !this.objectOrder.shipmentAddress.includes("Адрес не проверен: [")) {
            let newAddStr = "Адрес не проверен: [" + this.objectOrder.shipmentAddress + "]"
            this.objectOrder.shipmentAddress = newAddStr
            this.selectedAddress = newAddStr
          }

          // статус
          this.objectOrder.status = this.objectOrderDraft.orderStatus

          let res = await GlobalRequest.request("/order/save/draft", "POST", this.getObjForSave())
          if(!res.success) {
            this.errorText = "Заказ не был сохранен"
            this.successText = ""
          }
          else {
            this.errorText = ""
            this.successText = "Заказ успешно сохранен"
            this.$router.push({
                path: '/orders',
            });
          }
        } else {
          this.$refs.confirmModal.open(
            () => {},
            "Машина №" + errorCar + " загружена более 100%.<br>Необходимо добавить машину и<br>перенести в нее часть товаров."
          );
        }

        this.loadSaveOrder = false
      }
    },

    calcelOrder() {
      this.$router.push({
          path: '/orders'
      });
    },

    async postOrder() { // Изменить статус при просмотре
      this.loadPostOrder = true

      let objForRequest = {
        status: "На согласовании (Поставщик)"
      }

      let res = await GlobalRequest.request("/order/" + this.idGetOrder + "/status", "POST", objForRequest)
      if(!res.success) {
        this.errorText = "Заказ не был размещен"
        this.successText = ""
      }
      else {
        this.objectOrder.status = "На согласовании (Поставщик)"
        this.errorText = ""
        this.successText = "Заказ успешно размещен"
        this.$router.push({
          path: '/order/detail',
          query: { id: this.objectOrder.id, type: 'view' },
        });
      }

      this.loadPostOrder = false
    },

    async editOrder() {
      this.$router.push({
          path: '/order/detail',
          query: { id: this.objectOrder.id, type: 'edit' },
      });

      setTimeout(() => {
        window.location.reload();
      }, 100);
    },

    async cancelOrder() {
      this.loadCancelOrder = true

      let objForRequest = {
        status: "Отменен"
      }

      let res = await GlobalRequest.request("/order/" + this.idGetOrder + "/status", "POST", objForRequest)
      if(!res.success) {
        this.errorText = "При отмене заказа произошла ошибка"
        this.successText = ""
      }
      else {
        this.objectOrder.status = "Отменен"
        this.errorText = ""
        this.successText = "Заказ отменен"
        this.$router.push({
            path: '/order/detail',
            query: { id: this.objectOrder.id, type: 'view' },
        });
      }

      this.loadCancelOrder = false
    },

    async approveOrder() {
      this.loadApproveOrder = true

      let objForRequest = {
        status: "В работе"
      }

      let res = await GlobalRequest.request("/order/" + this.idGetOrder + "/status", "POST", objForRequest)
      if(!res.success) {
        this.errorText = "При согласовании заказа произошла ошибка"
        this.successText = ""
      }
      else {
        this.objectOrder.status = "В работе"
        this.errorText = ""
        this.successText = "Заказ согласован"
        this.$router.push({
            path: '/order/detail',
            query: { id: this.objectOrder.id, type: 'view' },
        });
      }

      this.loadApproveOrder = false
    },

    copyOrder() {
      this.$router.push({
          path: '/order/create',
          query: { id: this.objectOrder.id},
      });
    },

    isEmptyObj(obj) {
      for (let key in obj) {
        if (key in obj) {
            return false; // Если объект содержит хотя бы одно свойство, возвращаем false
        }
      }
      return true;
    },

    addShipmentAddress(address) {
      this.selectedAddress = address
      this.haveNewAddress = false
    },

    saveAddress(newAddressArray) {
      let addressStr = ""
      if(newAddressArray) {
        newAddressArray.forEach(field => {
          if(!this.isEmpty(field))
            addressStr += field + ", "
        });

        // Удаляем последнюю запятую и пробел
        addressStr = addressStr.slice(0, -2);

        this.objectOrder.shipmentAddress = addressStr
        this.selectedAddress = addressStr

        this.showFormAddAddress = false
        this.haveNewAddress = true
      }

      // console.log(this.objectOrder.shipmentAddress)
      // console.log(this.selectedAddress)
    },

    showFormAddAddressMethod() {
      this.showFormAddAddress = true
    },

    haveNewAddressFalse() {
      this.haveNewAddress = false
    },

    editShipmentAddress(newVal) {
      this.objectOrder.shipmentAddress = newVal
    },

    openFileDialog() {
      this.$refs.fileInput.click(); // Открываем диалог выбора файлов
    },

    // Получить список сообщений
    async getMessages() {
      this.loadingMessages = true
      let objForRequest = {
        "order_id": parseInt(this.idGetOrder)
      }

      let res = await GlobalRequest.request("/order-message/list", "POST", objForRequest)
      if(!res.success) {
        // console.log("Ошибка получения списка сообщений")
        // console.log(res)
      }
      else {
        // console.log("Получен список сообщений")
        // console.log(res)
        if(res.data && res.data.length > 0) {
          // от старого до нового
          this.orderMessages = res.data.sort((a, b) => a.id - b.id);
          // console.log(this.orderMessages)
        }
      }
      this.loadingMessages = false
    },

    handleFileChange(event) {
      const selectedFiles = Array.from(event.target.files);
      const maxFilesSize = this.maxFilesSize * 1024 * 1024; // Максимальный размер в байтах
      const currentSize = this.files.reduce((total, file) => total + file.size, 0); // Текущий размер загруженных файлов
      const availableSlots = this.maxFiles - this.files.length; // Доступные слоты

      const newFiles = []; // Новый массив для хранения валидных файлов

      for (const file of selectedFiles) {
        if (this.uniqueFiles.has(file.name)) {
          this.errorMessage = `Файл ${file.name} уже добавлен.`
          continue;
        } 
        
        if (newFiles.length >= availableSlots) {
          this.errorMessage = "Максимальное количество файлов - 10"
          continue;
        }

        const newSize = currentSize + file.size + newFiles.reduce((total, f) => total + f.size, 0); // Считаем новый размер

        if (newSize > maxFilesSize) {
          this.errorMessage = `Максимальный размер загружаемых файлов - ${this.maxFilesSize} Mb`
          continue;
        }

        // Если все проверки пройдены, добавляем файл в новый массив
        newFiles.push(file);

        // Очистить ошибки
        this.errorMessage = ""
      }

      // Добавляем только валидные файлы, если они есть
      if (newFiles.length > 0) {
        this.files.push(...newFiles);
        newFiles.forEach(file => this.uniqueFiles.add(file.name));
      }
    },

    removeFile(index) {
      const removedFileName = this.files[index].name; // имя удаляемого файла
      this.files.splice(index, 1);

      // Удаляем имя из множества уникальных файлов
      this.uniqueFiles.delete(removedFileName); 

      this.errorMessage = ""
    },

    prepareFilesForRequest() {
      const filePromises = this.files.map(file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Извлекаем строку base64 из data URL
            const fileObj = {
              name: file.name,
              extension: file.name.split('.').pop(), // Извлекаем расширение файла
              file_content: base64data
            };
            resolve(fileObj);
          };
          reader.onerror = reject; // Обрабатываем ошибки
          reader.readAsDataURL(file); // Читаем файл как Data URL
        });
      });

      return Promise.all(filePromises); // Ждем завершения всех промисов
    },

    async sendMessage(message) {
      if(message) {
        message.error = 0
        message.send = 0

        let objForRequest = {
            "user_id": message.user_id,
            "message_text": message.message_text,
            "message_date_time": message.message_date_time,
            "order_id": message.order_id,
            "company_id": message.company_id,
            "request_type": message.request_type,
            "files": message.files
          }

        // console.log("Повторная отправка запроса на создание сообщения")
        // console.log(objForRequest)

        let res = await GlobalRequest.request("/order-message/send", "POST", objForRequest)
        if(!res.success) {
          // console.log("Ошибка")
          // console.log(res)
          message.error = 1
          message.send = 1
        }
        else {
          // console.log("Сохранено")
          // console.log(res)
          message.error = 0
          message.send = 1
        }
      } 
      else {
        if(!this.isEmpty(this.newMessage)) {
          let newID = this.sendingMessages.length

          let objForRequest = {
            "user_id": parseInt(this.userID),
            "message_text": this.newMessage,
            "message_date_time": this.timezoneDate(new Date()),
            "order_id": parseInt(this.idGetOrder),
            "company_id": this.objectOrder.contrAgent.id,
            "request_type": "сообщение",
            "files": []
          }

          let objNewMessage = JSON.parse(JSON.stringify(objForRequest))
          objNewMessage.id = newID
          objNewMessage.created = this.getCurrentTime()
          objNewMessage.send = 0
          objNewMessage.error = 0
          this.sendingMessages.push(objNewMessage)

          // console.log(this.sendingMessages)
          this.newMessage = ""

          setTimeout(() => {
            this.scrollToBottom();
          }, 100);

          if(this.files && this.files.length > 0) {
            this.prepareFilesForRequest().then(encodedFiles => {
              objForRequest.files = encodedFiles // Добавляем подготовленные файлы
              let addedNewMessage = this.sendingMessages.find(message => message.id == newID);
              addedNewMessage.files = encodedFiles
              this.files = []
              // Запрос
              this.querySendMessage(objForRequest, newID)
            }).catch(error => {
              console.error("Ошибка при подготовке файлов:", error);
            });
          } else {
            this.querySendMessage(objForRequest, newID)
          }
        }
      }
    },

    async querySendMessage(objForRequest, newID) {
      // console.log("Объект для запроса создания сообщения")
      // console.log(objForRequest)
      // Запрос на сохранение в Б24
      let res = await GlobalRequest.request("/order-message/send", "POST", objForRequest)
      if(!res.success) {
        // console.log("Ошибка")
        // console.log(res)
        let addedNewMessage = this.sendingMessages.find(message => message.id == newID);
        addedNewMessage.error = 1
        addedNewMessage.send = 1
      }
      else {
        // console.log("Сохранено")
        // console.log(res)

        let addedNewMessage = this.sendingMessages.find(message => message.id == newID);
        addedNewMessage.error = 0
        addedNewMessage.send = 1
      }
    },

    getCurrentTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      return `${hours}:${minutes}`;
    },

    formattedTime(created) {
      const [datePart, timePart] = created.split(' ');
      const [day, month, year] = datePart.split('.');
      const formattedDateString = `${year}-${month}-${day}T${timePart}`; // create a valid ISO format
      const messageDate = new Date(formattedDateString);
      const today = new Date();

      // Устанавливаем часы и минуты
      const options = { hour: '2-digit', minute: '2-digit', hour12: false };

      if (messageDate.getDate() === today.getDate() &&
          messageDate.getMonth() === today.getMonth() &&
          messageDate.getFullYear() === today.getFullYear()) {
        // Если сообщение создано сегодня, возвращаем только время
        return messageDate.toLocaleTimeString('ru-RU', options);
      } else {
        // Если не сегодня, возвращаем дату в формате DD.MM.YYYY
        const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return messageDate.toLocaleDateString('ru-RU', dateOptions) + ' ' + messageDate.toLocaleTimeString('ru-RU', options);
      }
    },

    scrollToBottom() {
      const container = this.$refs.chatContainer;
      if (container) {
        container.scrollTop = container.scrollHeight; // Прокрутка к низу
      }
    },

    waitForElements() {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          const elements = document.querySelectorAll('.chat-message-of-query');
          if (elements.length > 0) {
            clearInterval(interval);
            resolve();
          }
        }, 100); // Проверяем каждые 100 мс
      });
    },

    setupIntersectionObserver() {
      const options = {
        root: null, // Использовать viewport как корень
        rootMargin: '0px',
        threshold: 0.9, // 90% видимости
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let id = entry.target.id
            if(!this.messagesId.includes(id)) {
              this.messagesId.push(id)
            }
          }
        });
      }, options);

      // Наблюдаем за каждым блоком
      const blocks = document.querySelectorAll('.chat-message-of-query');
      blocks.forEach((block) => {
        observer.observe(block);
      });
    },


    async getRelatedOrders(regionId) {
      let res = await GlobalRequest.request("/order/list/related?regionId=" + regionId, "GET")
      // console.log("Связанные заказы")
      // console.log(res)
      if(res.success) {
        let arrayRelatedOrders = []
        for(let order of res.data) {
          let obj = {}
          obj.id = order.id
          obj.name = order.orderNumberClient + " " + parseInt(order.occupancyRate) + "%"
          obj.occupancyRate = parseInt(order.occupancyRate)
          obj.shipmentDate = order.shipmentDate
          obj.status = order.status
          obj.carId = 0
          arrayRelatedOrders.push(obj)
        }
        this.allRelatedOrders = arrayRelatedOrders

        this.allRelatedOrders.push(...this.oldRelatedOrders);
      }
      // else
      //   this.allRelatedOrders = []

      // Удаление дубликатов по 'id'
      const uniqueOrders = this.allRelatedOrders.filter((order, index, self) =>
        index === self.findIndex((o) => (
          o.id === order.id
        ))
      );
      this.allRelatedOrders = uniqueOrders;

      // console.log(this.allRelatedOrders)

    },

    addOrderCar() {
      // Находим максимальное значение carId в существующих объектах
      const maxId = this.objectOrder.cars.reduce((max, car) => {
        return car.carId > max ? car.carId : max;
      }, 0);

      let newCar = {
        carId: maxId + 1,
        shipmentDate: null,
        relatedOrders: [],
        summ: 0,
        orderWeight: 0,
        occupancyRate: 0,
        items: []
      }

      this.objectOrder.cars.push(newCar);
    },

    // Удалить машину
    delCar(carId) {
      let carItems = this.objectOrder.cars.find(car => car.carId == carId).items;
      // console.log(carId)
      // console.log(carItems)
      if(carItems.length > 0) {
        this.$refs.confirmModal.open(
          () => {
            this.removeCar(carId);
            this.updateCarIds(); // Обновляем нумерацию после удаления
            this.updateSelectedServiceCars(carId)
          },
          "Вы действительно хотите удалить машину с товарами №" + carId + " ?" 
        );
      } else {
        this.removeCar(carId)
        this.updateCarIds(); // Обновляем нумерацию после удаления
        this.updateSelectedServiceCars(carId)
      }
    },
    removeCar(carId) {
      this.objectOrder.cars = this.objectOrder.cars.filter(car => car.carId !== carId);
      
      // Обновить принадлежность связанных заказов
      for (let order of this.allRelatedOrders) {
        // console.log(order)
        if(order.carId == carId) {
          order.carId = 0
        }
      }

    },

    updateCarIds() {
      // Обновляем id автомобилей, чтобы они были последовательными
      this.objectOrder.cars.forEach((car, index) => {
        car.carId = index + 1; 
      });

      this.selectedItems.forEach((obj, index) => {
        obj.carId = index + 1; 
      });
    },

    updateSelectedServiceCars(carId) {
      // Удалить машину из объекта услуг
      // this.objectOrder.services.forEach(service => {
      //   service.cars = service.cars.filter(car => car.id != carId);

      //   service.cars = service.cars.map((car, index) => {
      //     return { id: index + 1 }; // Новый id начинается с 1 и последовательный
      //   });
      // });

      // this.selectedCarsServiceWithObj.forEach(service => {
      //     service.carsId = service.carsId.filter(serviceCarId => serviceCarId != carId);
      // });
      
      // console.log(this.objectOrder.services)
      // console.log(this.selectedCarsService)
      // console.log(this.selectedCarsServiceWithObj)
      console.log(carId)
      // Все услуги чистим
      this.objectOrder.services.forEach(service => {
        service.cars = []
      });

      this.selectedCarsServiceWithObj = []
    },

    handleItemsRemoveChange(carId, itemId) {
      // Инициализируем массив для машины, если он еще не существует
      if (!this.selectedItemsDel[carId]) {
        this.selectedItemsDel[carId] = [];
      }

      const index = this.selectedItemsDel[carId].indexOf(itemId);

      // Добавляем или удаляем элемент из выбранных
      if (index === -1) {
        this.selectedItemsDel[carId].push(itemId);
      } else {
        this.selectedItemsDel[carId].splice(index, 1);
      }
    },

    // Метод для проверки, выбран ли элемент
    isSelectedRemoveItem(carId, itemId) {
      return this.selectedItemsDel[carId]?.includes(itemId) || false;
    },

    selectedRelatedOrders(carId, selectedElements) {
      if(this.typePage != "view") {
        let relatedOrderIds = selectedElements.map(({ id }) => id);
        let car = this.objectOrder.cars.find(car => car.carId === carId);
        if (car) {
          car.relatedOrders = relatedOrderIds;
        }

        for (let order of this.allRelatedOrders) {
          if (relatedOrderIds.includes(order.id)) {
              order.carId = carId; // Если id есть в relatedOrderIds, устанавливаем carId
          } else {
            if(order.carId == carId) {
              order.carId = 0; // Если id нет в relatedOrderIds, устанавливаем carId в 0
            }
          }
        }

        // console.log(carId)
        // console.log(selectedElements)
        // console.log("Изменена принадлежность к машинам")
        // console.log(this.allRelatedOrders) 
      }
    },

    // Хотя бы один заказ должен быть в статусе 'На согласовании (Клиент)'
    getStatuses() {
      let showBtn = false
      if(this.typePage == 'view') {
        let statuses = []

        const statusesD = this.objectOrder.relatedOrdersD.map(order => order.status);
        const statusesS = this.objectOrder.relatedOrdersS.map(order => order.status);
        statuses = statusesD.concat(statusesS);
        statuses.push(this.objectOrder.status)

        // console.log(statuses)

        let hasClientCoordination = statuses.some(status => status == "На согласовании (Клиент)");
        if(hasClientCoordination) {
          showBtn = true
        }

      }
      return showBtn
    },

    // Отслупы по тысячным в числах
    formatNumber(numberText) {
      if(numberText) {
        return numberText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      } 
    },

    updateNewAddressArrayForm(val) {
      this.newAddressArrayForm = val
    },

    getCarItems(list, carId) {
      const rec = list.find(x => x.carId == carId);
      return rec?.items ?? [];
    },

    generateRowId() {
      return (
        Date.now().toString(36) +
        Math.random().toString(36).substr(2, 9)
      );
    },

    async downloadFile() {
      try {
        let v1File = this.objectOrder?.v1File ?? null

        if (!v1File) {
          let res = await GlobalRequest.request("/order/" + this.idGetOrder + "/v1", "GET");
          if(res?.success && res?.data) {
            v1File = res.data
          }
        }

        console.log("Файл заказа")
        console.log(v1File)

        if (!v1File?.path) return

        const link = document.createElement('a')
        link.href = v1File.path
        link.download = v1File.name || 'order_' + this.idGetOrder + '_v1'
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch(e) {
        console.error('Ошибка скачивания файла заказа: ', e)
      }
    }

  }
}
</script>
